/**
 * 한국어 사전 — 키 집합의 SSOT. `en.ts` 는 이 키를 전부 가져야 컴파일된다.
 * 키는 `{화면}.{요소}` 두 단계 camelCase, 값 안의 `{name}` 은 보간 자리표시자다.
 */
export const ko = {
  "imageRelay.downloadTitle": "Windows 앱",
  "imageRelay.downloadDescription":
    "지정한 Windows 폴더에 새 이미지가 저장되면 내 Locktree 계정으로 자동 전송합니다.",
  "imageRelay.downloadFormat":
    "v{version} · Windows 10/11 · ZIP · Python 설치 불필요",
  "imageRelay.downloadChecking": "로그인 상태를 확인하고 있습니다…",
  "imageRelay.downloadConnectionNotice":
    "미리보기 버전입니다. 계정 연결과 이미지 자동 전송은 서비스 업데이트 후 사용할 수 있습니다.",
  "imageRelay.downloadWindows": "Windows 프로그램 다운로드",
  "imageRelay.downloadPreparing": "프로그램을 다운로드하는 중…",
  "imageRelay.downloadMembersOnly":
    "로그인한 회원만 프로그램을 다운로드할 수 있습니다.",
  "imageRelay.downloadSessionExpired":
    "로그인이 만료되었습니다. 다시 로그인한 뒤 다운로드하세요.",
  "imageRelay.downloadRateLimited":
    "다운로드 요청이 많습니다. 잠시 후 다시 시도하세요.",
  "imageRelay.downloadUnavailable":
    "프로그램을 다운로드할 수 없습니다. 잠시 후 다시 시도하세요.",
  "imageRelay.downloadStepRun": "ZIP 압축을 풀고 ImageRelay.exe를 실행합니다.",
  "imageRelay.downloadStepSignIn":
    "앱에서 Locktree에 로그인하고 저장할 계정의 연결을 허용합니다.",
  "imageRelay.downloadStepFolder":
    "감시 폴더의 ‘찾아보기’로 폴더를 고른 뒤 ‘설정 저장 → 감시 시작’을 누릅니다.",
  "imageRelay.title": "Windows 앱 연결",
  "imageRelay.description":
    "Image Relay for Windows를 Locktree 계정에 연결합니다.",
  "imageRelay.loading": "계정과 연결 요청을 확인하고 있습니다…",
  "imageRelay.signInHelp": "이미지를 저장할 Locktree 계정으로 로그인하세요.",
  "imageRelay.signIn": "Locktree로 로그인",
  "imageRelay.account": "이미지가 저장될 계정",
  "imageRelay.permission":
    "앱에서 선택한 폴더의 이미지를 이 계정으로 업로드하도록 허용합니다.",
  "imageRelay.confirmDevice":
    "직접 Windows 앱에서 로그인을 시작한 경우에만 연결을 허용하세요.",
  "imageRelay.approve": "앱 연결 허용",
  "imageRelay.deny": "취소",
  "imageRelay.connecting": "앱으로 돌아가는 중…",
  "imageRelay.invalidRequest":
    "요청이 만료되었거나 유효하지 않습니다. Windows 앱에서 로그인을 다시 시작하세요.",
  "imageRelay.accountChanged":
    "확인한 계정이 변경되었습니다. Windows 앱에서 로그인을 다시 시작하세요.",
  "imageRelay.unavailable":
    "연결을 확인할 수 없습니다. 잠시 후 Windows 앱에서 다시 시도하세요.",
  "app.documentTitle": "Locktree - 전문 포커 솔버",
  "nav.solver": "솔버",
  "nav.aiSetup": "AI 셋업",
  "nav.history": "히스토리",
  "nav.solutions": "솔루션",
  "nav.easySolutions": "쉬운 솔루션",
  "nav.settings": "설정",
  "nav.signIn": "로그인",
  "nav.logout": "로그아웃",
  "nav.openMenu": "메뉴 열기",
  "nav.closeMenu": "메뉴 닫기",
  "nav.language": "언어",
  "common.dismiss": "닫기",
  "common.cancel": "취소",
  "common.close": "닫기",
  "common.save": "저장",
  "common.delete": "삭제",
  "common.clear": "지우기",
  "common.remove": "제거",
  "common.retry": "다시 시도",
  "common.refresh": "새로고침",
  "common.edit": "편집",
  "common.copy": "복사",
  "common.error": "오류:",
  "common.warning": "경고:",
  "common.fold": "폴드",
  "common.check": "체크",
  "common.call": "콜",
  "common.bet": "벳",
  "common.raise": "레이즈",
  "common.allIn": "올인",
  "solverStreet.preflop": "프리플랍",
  "solverStreet.flop": "플랍",
  "solverStreet.turn": "턴",
  "solverStreet.river": "리버",
  "solverStreet.unknown": "알 수 없음",
  "solverAction.fold": "폴드",
  "solverAction.check": "체크",
  "solverAction.call": "콜",
  "solverAction.bet": "벳",
  "solverAction.raise": "레이즈",
  "solverAction.allin": "올인",
  "solverAction.short.call": "콜",
  "solverAction.short.bet": "벳",
  "solverAction.short.raise": "레이즈",
  "solverAction.short.allin": "올인",
  "common.itemCount.one": "{count}개",
  "common.itemCount.other": "{count}개",
  "settings.title": "설정",
  "settings.language": "언어",
  "settings.languageDescription":
    "화면에 표시할 언어를 선택합니다. 선택은 이 브라우저에 저장됩니다.",
  "locale.ko": "한국어",
  "locale.en": "English",
  "about.tagline": "GTO 포커 솔버",
  "about.aiSetup": "AI 셋업",
  "about.aiSetupDescription": "스크린샷을 업로드하면 자동으로 분석합니다",
  "about.easySolutionsDescription": "쉬운 솔루션의 프리플랍 전략 뷰어를 엽니다",
  "about.preflopSolutions": "프리플랍 솔루션",
  "about.preflopSolutionsDescription":
    "전략 뷰어로 프리플랍 GTO 솔루션을 확인합니다",
  "about.history": "히스토리",
  "about.historyDescription": "이전 솔브와 저장한 설정을 확인합니다",
  "about.client": "클라이언트",
  "about.server": "서버",
  "about.loading": "불러오는 중...",
  "about.deployed": "배포 시각",
  "authError.signInFailed": "로그인 실패",
  "authError.title": "로그인할 수 없습니다",
  "authError.retryLogin": "다시 로그인",
  "authError.goHome": "홈으로",
  "boardSelector.randomFlop": "무작위 플랍",
  "boardSelector.expectedBoard":
    "편집한 트리는 {count}장 보드를 전제로 합니다.",
  "cardPicker.selectCard": "카드 선택",
  "convergence.previewMode": "미리보기 모드",
  "convergence.iteration": "반복 {iteration}",
  "convergence.confidence": "신뢰도 {confidence}%",
  "convergence.strategyStability": "전략 안정성: {percent}%",
  "convergence.backToSolver": "솔버로 돌아가기",
  "rangeEditor.weight": "가중치:",
  "rangeEditor.comboCount.one": "{count} 콤보 ({percent}%)",
  "rangeEditor.comboCount.other": "{count} 콤보 ({percent}%)",
  "resultCompare.combos": "콤보",
  "resultCompare.equity": "에퀴티",
  "handRange.title": "핸드 레인지",
  "handRange.notInRange": "레인지에 없음",
  "handRange.frequency": "빈도",
  "handRange.comboCount.one": "{count} 콤보 ({percent}%)",
  "handRange.comboCount.other": "{count} 콤보 ({percent}%)",
  "handRange.hoveredCombo.one": "{count} 콤보",
  "handRange.hoveredCombo.other": "{count} 콤보",
  "preflopAction.title": "프리플랍 액션 타임라인",
  "preflopAction.pot": "팟:",
  "preflopAction.result": "결과",
  "preflopAction.winner": "승자: {winner}",
  "preflopAction.totalPot": "총 팟: {pot}",
  "preflopAction.chips": "칩",
  "rangeSwitcher.regionLabel": "{player}의 GTO 액션 빈도 전환",
  "rangeSwitcher.loadedFromTree": "GTO 프리플랍 트리에서 불러온 레인지",
  "rangeSwitcher.dismiss": "GTO 레인지 전환 닫기",
  "rangeSwitcher.optionsLabel": "{player}의 액션 빈도 옵션",
  "rangeSwitcher.showRange": "{action} 레인지 보기",
  "rangeSwitcher.noHands": "핸드 없음",
  "rangeSwitcher.showRangeWithCombos.one":
    "{action} 레인지 보기 — {count} 콤보",
  "rangeSwitcher.showRangeWithCombos.other":
    "{action} 레인지 보기 — {count} 콤보",
  "treeConfig.startingPot": "시작 팟:",
  "treeConfig.effectiveStack": "유효 스택:",
  "treeConfig.rake": "레이크:",
  "treeConfig.rakeCap": "레이크 상한:",
  "treeConfig.oopBetSizes": "OOP 벳 사이즈",
  "treeConfig.differentDonkSizes": "동크 벳에 다른 사이즈 사용",
  "treeConfig.howToInput": "입력 방법",
  "treeConfig.betSizeInputHelp":
    "여러 벳 사이즈를 쉼표나 공백으로 구분해 입력할 수 있습니다. 비워 두면 벳이나 레이즈를 하지 않습니다.",
  "treeConfig.potPercentageHelp":
    "팟 비율을 숫자로 입력합니다(예: ‘50’). 레이즈는 먼저 콜한 뒤 지정한 팟 비율만큼 벳하는 방식으로 계산합니다. 예를 들어 팟이 100일 때 상대가 75를 벳했다면 50% 레이즈는 75 + (100 + 75 + 75) × 50% = 200입니다.",
  "treeConfig.betMultipleHelp":
    "이전 벳 사이즈의 배수를 입력합니다(예: ‘2.5x’). 레이즈에만 사용할 수 있습니다.",
  "treeConfig.allInHelp": "올인(예: ‘a’).",
  "treeConfig.constantAdditionHelp":
    "고정 가산값을 입력합니다(예: ‘100c’). 레이즈 횟수 상한도 지정할 수 있습니다(예: ‘20c3r’).",
  "treeConfig.geometricSizeHelp":
    "남은 스택을 같은 비율의 여러 벳으로 나누는 기하 사이즈입니다(예: ‘3e’). 현재 팟이 100이고 유효 스택이 400이면 ‘2e’는 100을 벳합니다. ‘e’ 앞 숫자를 생략하면 남은 스트리트 수(플랍=3, 턴=2, 리버=1)를 사용합니다. 레이즈에서는 이전 레이즈 횟수를 뺍니다. 예를 들어 리레이즈에서 ‘3e’는 ‘2e’가 됩니다. ‘e’ 뒤에 숫자를 붙여 최대 팟 비율을 제한할 수도 있습니다(예: ‘2e200’).",
  "treeConfig.flop": "플랍",
  "treeConfig.turn": "턴",
  "treeConfig.river": "리버",
  "treeConfig.bet": "벳:",
  "treeConfig.raise": "레이즈:",
  "treeConfig.donk": "동크:",
  "treeConfig.ipBetSizes": "IP 벳 사이즈",
  "treeConfig.copyIpToOop": "IP 사이즈를 OOP로 복사",
  "treeConfig.copyOopToIp": "OOP 사이즈를 IP로 복사",
  "treeConfig.addAllInThreshold": "올인 추가 임계값:",
  "treeConfig.addAllInThresholdHelp":
    "가능한 최대 벳 사이즈와 팟의 비율이 이 임계값보다 작은 모든 지점에 올인 액션을 추가합니다.",
  "treeConfig.forceAllInThreshold": "올인 강제 임계값:",
  "treeConfig.forceAllInThresholdHelp":
    "상대가 해당 벳 액션에 콜한 뒤 SPR(스택/팟 비율)이 이 임계값보다 낮으면 벳 액션을 올인으로 바꿉니다. 권장값은 약 15%~20%입니다.",
  "treeConfig.pioAllInThresholdHelp":
    "PioSOLVER의 ‘all-in threshold’와 비슷합니다. PioSOLVER는 초기 스택 대비 팟 커밋 비율이 임계값을 넘으면 벳 액션을 올인으로 바꿉니다.",
  "treeConfig.conversionFormulaHelp":
    "소수점 반올림을 무시한 변환식은 다음과 같습니다(s = 초기 SPR, r = PioSOLVER 임계값):",
  "treeConfig.thresholdFormula": "임계값 = s × (1 − r) / (1 + 2 × s × r).",
  "treeConfig.mergingThreshold": "병합 임계값:",
  "treeConfig.mergingThresholdHelp": "비슷한 사이즈의 벳 액션을 병합합니다.",
  "treeConfig.mergingAlgorithmHelp":
    "PioSOLVER와 같은 알고리즘입니다. 가장 큰 벳 사이즈(팟의 X%)를 선택하고 다음 부등식을 만족하는 다른 벳 액션(팟의 Y%)을 모두 제거합니다:",
  "treeConfig.mergingInequality": "(100 + X) / (100 + Y) < 1.0 + 임계값.",
  "treeConfig.mergingRepeatHelp":
    "남은 벳 중 다음으로 큰 사이즈에 같은 과정을 반복합니다.",
  "treeConfig.previewEditTree": "트리 미리보기 및 편집",
  "treeConfig.clearEditUnlock": "편집 지우기 및 잠금 해제",
  "treeConfig.addedLine.one": "추가한 라인:",
  "treeConfig.addedLine.other": "추가한 라인:",
  "treeConfig.removedLine.one": "제거한 라인:",
  "treeConfig.removedLine.other": "제거한 라인:",
  "treeConfig.boardMismatch":
    "편집한 트리는 {expected}장 보드를 전제로 하지만 현재 보드는 {actual}장입니다.",
  "treeConfig.resetEditedTree":
    "편집한 트리를 초기화하려면 ‘편집 지우기 및 잠금 해제’ 버튼을 누르세요.",
  "treeConfig.failedBuildBrokenTree":
    "오류: 트리를 빌드하지 못했습니다(손상된 트리를 불러왔나요?).",
  "treeConfig.pot": "팟 {pot}",
  "treeConfig.stack": "스택 {stack}",
  "treeConfig.playerWins": "{player} 승리",
  "treeConfig.noActions": "(액션 없음)",
  "treeConfig.invalidTerminal.one": "유효하지 않은 터미널:",
  "treeConfig.invalidTerminal.other": "유효하지 않은 터미널:",
  "treeConfig.addBetAction": "벳 액션 추가",
  "treeConfig.removeSelectedNode": "선택한 노드 제거",
  "treeConfig.betAmount": "벳 금액:",
  "treeConfig.percentOfPot": "(팟의 {percent}%)",
  "treeConfig.saveEdit": "편집 저장",
  "treeConfig.cancelEdit": "편집 취소",
  "treeConfig.oopRangeEmpty":
    "OOP 레인지가 비어 있습니다(핸드를 하나 이상 선택하세요).",
  "treeConfig.ipRangeEmpty":
    "IP 레인지가 비어 있습니다(핸드를 하나 이상 선택하세요).",
  "treeConfig.boardTooShort": "보드는 최소 세 장이어야 합니다.",
  "treeConfig.startingPotPositive": "시작 팟은 양수여야 합니다.",
  "treeConfig.startingPotTooLarge": "시작 팟이 너무 큽니다.",
  "treeConfig.startingPotMax": "시작 팟은 {max} 이하여야 합니다.",
  "treeConfig.effectiveStackPositive": "유효 스택은 양수여야 합니다.",
  "treeConfig.effectiveStackTooLarge": "유효 스택이 너무 큽니다.",
  "treeConfig.effectiveStackMax": "유효 스택은 {max} 이하여야 합니다.",
  "treeConfig.rakeNonNegative": "레이크는 0 이상이어야 합니다.",
  "treeConfig.rakeMax": "레이크는 100% 이하여야 합니다.",
  "treeConfig.rakeCapNonNegative": "레이크 상한은 0 이상이어야 합니다.",
  "treeConfig.rakeCapMax": "레이크 상한은 {max} 이하여야 합니다.",
  "treeConfig.invalidBetSize": "{name}: {value}",
  "treeConfig.addAllInNonNegative": "올인 추가 임계값은 0 이상이어야 합니다.",
  "treeConfig.forceAllInNonNegative": "올인 강제 임계값은 0 이상이어야 합니다.",
  "treeConfig.mergingNonNegative": "병합 임계값은 0 이상이어야 합니다.",
  "treeConfig.forceAllInHighWarning":
    "30%보다 높은 올인 강제 임계값은 권장하지 않습니다.\n도움말에서 의미를 확인하세요.",
  "treeConfig.invalidLine":
    "유효하지 않은 라인이 있습니다(손상된 설정을 불러왔나요?).",
  "treeConfig.invalidConfiguration":
    "유효하지 않은 설정입니다(손상된 설정을 불러왔나요?).",
  "treeConfig.oopFlopBet": "OOP 플랍 벳",
  "treeConfig.oopFlopRaise": "OOP 플랍 레이즈",
  "treeConfig.oopTurnBet": "OOP 턴 벳",
  "treeConfig.oopTurnRaise": "OOP 턴 레이즈",
  "treeConfig.oopTurnDonk": "OOP 턴 동크",
  "treeConfig.oopRiverBet": "OOP 리버 벳",
  "treeConfig.oopRiverRaise": "OOP 리버 레이즈",
  "treeConfig.oopRiverDonk": "OOP 리버 동크",
  "treeConfig.ipFlopBet": "IP 플랍 벳",
  "treeConfig.ipFlopRaise": "IP 플랍 레이즈",
  "treeConfig.ipTurnBet": "IP 턴 벳",
  "treeConfig.ipTurnRaise": "IP 턴 레이즈",
  "treeConfig.ipRiverBet": "IP 리버 벳",
  "treeConfig.ipRiverRaise": "IP 리버 레이즈",
  "treeConfig.initializeHandlerFailed": "솔버 핸들러를 초기화하지 못했습니다.",
  "treeConfig.cannotBuild": "트리를 빌드할 수 없습니다: {error}",
  "treeConfig.buildFailed": "트리를 빌드하지 못했습니다: {error}",
  "treeConfig.loadTreeFailed": "게임 트리를 불러오지 못했습니다.",
  "treeConfig.errorWithMessage": "오류: {error}",
  "treeConfig.addActionFailed":
    "액션을 추가하지 못했습니다. 콘솔에서 자세한 내용을 확인하세요.",
  "treeConfig.removeAddedLineFailed":
    "추가한 라인을 제거하지 못했습니다. 콘솔에서 자세한 내용을 확인하세요.",
  "treeConfig.restoreRemovedLineFailed":
    "제거한 라인을 복원하지 못했습니다. 콘솔에서 자세한 내용을 확인하세요.",
  "nodeLock.title": "노드 잠금",
  "nodeLock.strategy": "전략:",
  "nodeLock.nodeRemoval": "노드 제거:",
  "nodeLock.rangeLock": "레인지 잠금:",
  "nodeLock.evLock": "EV 잠금:",
  "nodeLock.sortBy": "정렬:",
  "nodeLock.lockId": "잠금 ID",
  "nodeLock.lockType": "잠금 유형",
  "nodeLock.nodePath": "노드 경로",
  "nodeLock.status": "상태",
  "nodeLock.sortAscending": "오름차순 정렬",
  "nodeLock.sortDescending": "내림차순 정렬",
  "nodeLock.filter": "필터:",
  "nodeLock.allLocks": "모든 잠금",
  "nodeLock.strategyOnly": "전략만",
  "nodeLock.nodeRemovalOnly": "노드 제거만",
  "nodeLock.rangeLockOnly": "레인지 잠금만",
  "nodeLock.evLockOnly": "EV 잠금만",
  "nodeLock.enabledOnly": "활성만",
  "nodeLock.disabledOnly": "비활성만",
  "nodeLock.loading": "잠금 불러오는 중...",
  "nodeLock.disabled": "(비활성)",
  "nodeLock.noDescription": "설명 없음",
  "nodeLock.path": "경로: {path}",
  "nodeLock.toggle": "잠금 전환",
  "nodeLock.enabling": "활성화 중...",
  "nodeLock.disabling": "비활성화 중...",
  "nodeLock.enable": "활성화",
  "nodeLock.disable": "비활성화",
  "nodeLock.copy": "잠금 복사",
  "nodeLock.edit": "잠금 편집",
  "nodeLock.remove": "잠금 제거",
  "nodeLock.deleting": "삭제 중...",
  "nodeLock.lockedStrategies": "잠근 전략:",
  "nodeLock.hand": "핸드 {index}:",
  "nodeLock.removedActions": "제거한 액션:",
  "nodeLock.indices": "(인덱스: {indices})",
  "nodeLock.handCombinations.one": "{count}개 핸드 조합 잠금",
  "nodeLock.handCombinations.other": "{count}개 핸드 조합 잠금",
  "nodeLock.weights": "(가중치: {weights}{ellipsis})",
  "nodeLock.noFilterMatches": "현재 필터와 일치하는 잠금이 없습니다",
  "nodeLock.noLocks": "설정한 잠금이 없습니다",
  "nodeLock.createForCurrentNode": "현재 선택한 노드에 잠금 추가",
  "nodeLock.lockThisNode": "이 노드 잠금",
  "nodeLock.addLock": "+ 잠금 추가",
  "nodeLock.loadFailed": "잠금을 불러오지 못했습니다",
  "nodeLock.loadNetworkError":
    "잠금을 불러오는 중 네트워크 오류가 발생했습니다",
  "nodeLock.toggleFailed": "잠금 상태를 바꾸지 못했습니다",
  "nodeLock.toggleNetworkError":
    "잠금 상태를 바꾸는 중 네트워크 오류가 발생했습니다",
  "nodeLock.removeConfirmation": "이 잠금을 제거할까요?",
  "nodeLock.removeFailed": "잠금을 제거하지 못했습니다",
  "nodeLock.removeNetworkError":
    "잠금을 제거하는 중 네트워크 오류가 발생했습니다",
  "nodeLock.strategyType": "전략",
  "nodeLock.nodeRemovalType": "노드 제거",
  "nodeLock.rangeLockType": "레인지 잠금",
  "nodeLock.evLockType": "EV 잠금",
  "nodeLock.foldAction": "폴드",
  "nodeLock.callCheckAction": "콜/체크",
  "nodeLock.betRaiseAction": "벳/레이즈",
  "nodeLock.action": "액션 {index}",
  "runSolver.buildNewTree": "새 트리 빌드",
  "runSolver.status": "상태: {status}",
  "runSolver.configureThenBuild":
    "솔버 설정을 구성한 뒤 ‘새 트리 빌드’를 눌러 시작하세요.",
  "runSolver.setupRanges":
    "AI 셋업에서 레인지를 설정하거나 OOP/IP 레인지에서 직접 설정하세요",
  "runSolver.configureTree": "트리 설정에서 보드·팟·스택을 구성하세요",
  "runSolver.buildThenRun": "트리를 빌드한 뒤 솔버를 실행하세요",
  "runSolver.viewTree": "트리 보기",
  "runSolver.precisionMode": "정밀도 모드:",
  "runSolver.precisionHelp":
    "정밀도 모드는 주로 메모리 사용량에 영향을 주지만 다른 효과도 있습니다.",
  "runSolver.fp32Help":
    "32비트 FP(부동소수점): 메모리 사용량이 한도(3.9GB)보다 작을 때 권장합니다. 약 7자리 유효숫자를 제공하며 성능도 더 좋습니다.",
  "runSolver.int16Help":
    "16비트 정수: 32비트 FP 모드를 사용할 수 없을 때 메모리 한도를 피하는 데 도움이 됩니다. 유효숫자가 약 4자리라 익스플로잇 가능성 목표 0.1% 미만에는 적합하지 않습니다. 성능도 32비트 FP보다 낮습니다.",
  "runSolver.fp32": "32비트 FP:",
  "runSolver.int16": "16비트 정수:",
  "runSolver.memoryRequirement": "{memory} RAM 필요{limit}",
  "runSolver.limitExceeded": " (한도 초과)",
  "runSolver.ramLimit": "RAM 한도: 3.9GB(브라우저 메모리 한도)",
  "runSolver.targetExploitability": "목표 익스플로잇 가능성:",
  "runSolver.targetHelp":
    "허용할 내시 균형과의 거리를 지정합니다. 값이 낮을수록 결과가 정확하지만 계산 시간이 늘어납니다.",
  "runSolver.detailedDescription": "자세한 설명:",
  "runSolver.targetDetails":
    "내시 균형 해를 얻으면 두 플레이어의 전략은 서로에 대한 MES(최대 착취 전략)가 됩니다. 이 성질을 이용해 얻은 전략과 내시 균형의 거리를 다음과 같이 정의합니다.",
  "runSolver.distanceFormula": "거리 = 상대의 MES EV − 상대의 현재 EV.",
  "runSolver.exploitabilityDetails":
    "이 거리는 항상 0 이상이며, 얻은 전략이 특정 내시 균형의 일부일 때만 0입니다. 익스플로잇 가능성은 두 플레이어 거리의 평균으로 정의합니다.",
  "runSolver.maxIterations": "최대 반복 횟수:",
  "runSolver.run": "솔버 실행",
  "runSolver.stop": "중지",
  "runSolver.pause": "일시정지",
  "runSolver.resume": "재개",
  "runSolver.running": "솔버 실행 중...",
  "runSolver.finalizing": "마무리 중...",
  "runSolver.paused": "솔버가 일시정지됐습니다.",
  "runSolver.finished": "솔버가 완료됐습니다.",
  "runSolver.starting": "솔버 시작 중...",
  "runSolver.iteration": "반복: {current} / {max}",
  "runSolver.solvingPrefix": "솔브 중... ",
  "runSolver.exploitabilityNotConverged":
    "{prefix}익스플로잇 가능성: 수렴하지 않음(팟의 {percent}%)",
  "runSolver.exploitability": "{prefix}익스플로잇 가능성: {value} ({percent}%)",
  "runSolver.strategyStability": "전략 안정성: {percent}%",
  "runSolver.time": "시간: {seconds}초",
  "runSolver.progressStalled":
    "진행 상황 업데이트가 멈췄습니다. 서버에 문제가 있을 수 있습니다.",
  "runSolver.previewResults": "결과 미리보기",
  "runSolver.invalidBoard": "유효하지 않은 보드입니다({count}장 필요).",
  "runSolver.buildingTree": "트리 빌드 중...",
  "runSolver.buildSuccess": "트리를 빌드했습니다",
  "runSolver.unknownError": "알 수 없는 오류",
  "runSolver.startFailed": "솔버를 시작하지 못했습니다: {error}",
  "runSolver.previewFailed": "결과를 미리 볼 수 없습니다: {error}",
  "runSolver.solverError": "솔버 오류: {error}",
  "addLock.editTitle": "노드 잠금 편집",
  "addLock.addTitle": "노드 잠금 추가",
  "addLock.lockType": "잠금 유형",
  "addLock.strategyLock": "전략 잠금",
  "addLock.nodeRemoval": "노드 제거",
  "addLock.rangeLock": "레인지 잠금",
  "addLock.strategyDescription":
    "노드에서 특정 핸드의 전략을 고정합니다(예: AA는 항상 레이즈).",
  "addLock.nodeRemovalDescription":
    "의사결정 트리에서 특정 액션을 제거합니다(예: 폴드 비활성화).",
  "addLock.rangeLockDescription":
    "특정 노드에서 플레이어 레인지 가중치를 잠급니다.",
  "addLock.quickTemplates": "빠른 템플릿",
  "addLock.clearTemplate": "템플릿 지우기",
  "addLock.selectTemplate": "-- 템플릿 선택(선택 사항) --",
  "addLock.nodePath": "노드 경로",
  "addLock.nodePathHint": "(쉼표로 구분한 액션 인덱스, 예: ‘0,1,2’)",
  "addLock.nodePathHelp":
    "비워 두면 루트 노드입니다. 예: ‘0’은 첫 번째 액션, ‘0,1’은 첫 번째 액션 뒤 두 번째 액션입니다.",
  "addLock.description": "설명",
  "addLock.descriptionPlaceholder": "예: AA는 항상 레이즈",
  "addLock.lockedStrategies": "잠근 전략",
  "addLock.strategyHint": "(핸드: 액션 확률)",
  "addLock.strategyHandLabel": "잠근 전략 {index}의 핸드",
  "addLock.strategyProbabilitiesLabel": "잠근 전략 {index}의 액션 확률",
  "addLock.handPlaceholder": "AA, AKs 등",
  "addLock.probabilitiesPlaceholder": "예: 0.0,1.0,0.0",
  "addLock.addHand": "+ 핸드 추가",
  "addLock.strategyExample":
    "예: 확률이 ‘0.0,1.0,0.0’인 ‘AA’는 0% 폴드, 100% 콜, 0% 레이즈를 뜻합니다. ‘AA’, ‘KK’, ‘AKs’(수딧), ‘AKo’(오프수딧) 같은 핸드 표기나 핸드 인덱스(0~1325)를 사용할 수 있습니다.",
  "addLock.removedActions": "제거한 액션",
  "addLock.removedActionsHint": "(제거할 액션 인덱스)",
  "addLock.removedActionsPlaceholder": "예: 0,2(폴드와 레이즈 제거)",
  "addLock.removedActionsHelp":
    "쉼표로 구분한 액션 인덱스를 입력하세요. 예: ‘0’은 폴드를, ‘0,2’는 폴드와 레이즈를 제거합니다.",
  "addLock.lockedRange": "잠근 레인지",
  "addLock.handNotation": "핸드 표기",
  "addLock.manualWeights": "수동 가중치",
  "addLock.notationPlaceholder": "예: AA, KK, QQ+, AKs, AKo",
  "addLock.notationHelp":
    "포커 표기로 핸드 조합을 입력하세요: AA, KK+, AKs, AKo, 77-22 등. 입력한 핸드는 가중치 1.0, 나머지는 0.0이 됩니다.",
  "addLock.weightsPlaceholder": "예: 1.0,1.0,0.5,0.0,...",
  "addLock.weightsHelp":
    "핸드 조합별 가중치 1326개를 쉼표로 구분해 입력하세요. 1.0은 항상 레인지에 포함, 0.0은 항상 제외를 뜻합니다.",
  "addLock.conflictsDetected": "⚠️ 잠금 충돌 가능성:",
  "addLock.conflictsHelp":
    "잠금을 만들 수는 있지만 기존 잠금과 예상치 못하게 상호작용할 수 있습니다.",
  "addLock.updating": "업데이트 중...",
  "addLock.adding": "추가 중...",
  "addLock.updateLock": "잠금 업데이트",
  "addLock.addLock": "잠금 추가",
  "addLock.sameTypeConflict":
    "이 노드에 다른 {type} 잠금이 이미 있습니다(ID: {id}).",
  "addLock.removalAffectsStrategy":
    "이곳에 노드 제거 잠금이 있어 제거한 액션이 전략 잠금에 영향을 줄 수 있습니다.",
  "addLock.strategyConflictsRemoval":
    "이곳에 전략 잠금이 있어 액션 제거가 잠근 전략과 충돌할 수 있습니다.",
  "addLock.rangeConflict":
    "이곳에 {type} 잠금이 있습니다. 레인지 잠금은 모든 핸드에 영향을 주며 다른 잠금을 덮어쓸 수 있습니다.",
  "addLock.parentRangeConflict":
    "이 레인지 잠금은 잠금 {id}의 부모 노드에 영향을 주어 하위 전략을 제한할 수 있습니다.",
  "addLock.parentHasRange":
    "부모 노드에 레인지 잠금({id})이 있어 이 잠금의 효과를 제한할 수 있습니다.",
  "addLock.parentHasRemoval":
    "부모 노드에 노드 제거 잠금({id})이 있어 사용 가능한 액션에 영향을 줄 수 있습니다.",
  "addLock.noStrategies":
    "핸드 전략이 없습니다. 액션 확률이 있는 핸드를 하나 이상 추가하세요(예: AA, 확률 0.0,1.0,0.0).",
  "addLock.strategyDefaultDescription": "전략 잠금",
  "addLock.nodeRemovalDefaultDescription": "노드 제거 잠금",
  "addLock.rangeDefaultDescription": "레인지 잠금",
  "addLock.noHandCombinations":
    "핸드 조합이 없습니다. 포커 핸드 표기를 입력하세요(예: ‘AA, KK+, AKs, AKo’).",
  "addLock.invalidNotation":
    "유효하지 않은 핸드 표기입니다: {error}. ‘AA’, ‘KK+’, ‘AKs’, ‘AKo’, ‘77-22’ 같은 표기를 사용하세요.",
  "addLock.noRangeWeights":
    "레인지 가중치가 없습니다. 0.0~1.0의 소수 1326개를 쉼표로 구분해 입력하세요.",
  "addLock.invalidWeightsFormat":
    "레인지 가중치 형식이 유효하지 않습니다. 쉼표로 구분한 소수 1326개가 필요하지만 숫자가 아닌 값이 있습니다.",
  "addLock.invalidWeight":
    "유효하지 않은 가중치입니다: {value}. 모든 레인지 가중치는 0.0~1.0이어야 합니다.",
  "addLock.weightCount":
    "레인지 잠금에는 모든 핸드 조합의 가중치 1326개가 필요합니다(현재 {count}개). 각 가중치는 가능한 시작 핸드 하나를 나타냅니다.",
  "addLock.invalidType": "유효하지 않은 잠금 유형입니다.",
  "addLock.addFailed": "잠금을 추가하지 못했습니다",
  "addLock.editRollback":
    "편집 중 원래 잠금을 제거하지 못했습니다. 변경 사항을 되돌렸습니다.",
  "addLock.changesRolledBack": "(변경 사항을 되돌렸습니다)",
  "addLock.rollbackFailed":
    "(경고: 롤백에 실패해 이전 잠금과 새 잠금이 모두 존재할 수 있습니다.)",
  "addLock.templatePremiumRaiseName": "프리미엄 핸드는 항상 레이즈",
  "addLock.templatePremiumRaiseDescription":
    "AA, KK, QQ는 항상 레이즈(폴드·콜 없음)",
  "addLock.templateAcesNeverFoldName": "포켓 에이스는 폴드하지 않음",
  "addLock.templateAcesNeverFoldDescription":
    "AA는 항상 콜 또는 레이즈(폴드 없음)",
  "addLock.templateWeakFoldName": "약한 핸드는 항상 폴드",
  "addLock.templateWeakFoldDescription":
    "낮은 페어(22~55)와 약한 오프수딧 핸드는 항상 폴드",
  "addLock.templateSuitedCallName": "수딧 커넥터는 항상 콜",
  "addLock.templateSuitedCallDescription":
    "중간 수딧 커넥터(76s~JTs)는 항상 콜/체크",
  "addLock.templateNoFoldName": "폴드 제거",
  "addLock.templateNoFoldDescription": "폴드 옵션 제거(콜 또는 레이즈 강제)",
  "addLock.templateNoRaiseName": "레이즈 제거",
  "addLock.templateNoRaiseDescription": "레이즈 옵션 제거(폴드 또는 콜 강제)",
  "addLock.templateAllInFoldName": "올인 또는 폴드만",
  "addLock.templateAllInFoldDescription":
    "콜/체크 옵션 제거(폴드 또는 레이즈 강제)",
  "addLock.templateTightRangeName": "타이트 레인지(15%)",
  "addLock.templateTightRangeDescription": "프리미엄 핸드만: 높은 페어, AK, AQ",
  "addLock.templateStandardRangeName": "표준 오픈 레인지(20%)",
  "addLock.templateStandardRangeDescription": "일반적인 버튼 오픈 레인지",
  "addLock.templateWideRangeName": "와이드 레인지(35%)",
  "addLock.templateWideRangeDescription": "공격적인 와이드 오픈 레인지",
  "addLock.templatePremiumRangeName": "프리미엄 레인지(5%)",
  "addLock.templatePremiumRangeDescription": "최상위 프리미엄 핸드: AA, KK, AK",
  "addLock.templatePairsName": "포켓 페어만",
  "addLock.templatePairsDescription": "22부터 AA까지 모든 포켓 페어",
  "addLock.templateBroadwayName": "브로드웨이 핸드",
  "addLock.templateBroadwayDescription": "높은 카드 조합(T 이상)",
  "aiSetup.quickSetup": "빠른 설정",
  "aiSetup.quickSetupWithImage":
    "스크린샷을 분석하거나 이미지를 제거하고 샘플 핸드로 시작하세요.",
  "aiSetup.quickSetupWithoutImage":
    "테이블 스크린샷을 끌어다 놓거나 샘플 핸드로 시작하세요.",
  "aiSetup.dropScreenshot": "스크린샷을 여기에 끌어다 놓으세요",
  "aiSetup.or": "또는",
  "aiSetup.uploadScreenshot": "테이블 스크린샷 업로드",
  "aiSetup.chooseImage": "이미지 선택",
  "aiSetup.imageFormatHelp": "모든 포커 클라이언트의 PNG 또는 JPG · AI로 분석",
  "aiSetup.noScreenshot": "스크린샷이 없나요?",
  "aiSetup.textOrSampleHelp":
    "2단계에 OHH JSON이나 Bracketed Text를 붙여넣거나 샘플 핸드를 불러오세요.",
  "aiSetup.loadSample": "샘플 핸드 히스토리 입력",
  "aiSetup.replace": "교체",
  "aiSetup.remove": "제거",
  "aiSetup.parsing": "분석 중...",
  "aiSetup.parseImage": "이미지 분석",
  "aiSetup.previewAlt": "미리보기",
  "aiSetup.handHistory": "핸드 히스토리",
  "aiSetup.reviewParsedHand":
    "솔버에 적용하기 전에 AI가 놓친 부분이 없는지 분석한 핸드를 검토하고 수정하세요.",
  "aiSetup.importHandHelp":
    "여기에 OHH JSON이나 Bracketed Text를 붙여넣거나 1단계에서 핸드를 가져오세요.",
  "aiSetup.handHistoryView": "핸드 히스토리 보기",
  "aiSetup.textView": "텍스트",
  "aiSetup.uiView": "UI 보기",
  "aiSetup.pokerStarsViewHelp":
    "PokerStars(Pokercraft) 형식으로 변환한 읽기 전용 텍스트",
  "aiSetup.copy": "복사",
  "aiSetup.copied": "복사됨",
  "aiSetup.copyFailed": "실패",
  "aiSetup.download": "다운로드",
  "aiSetup.cardMismatchTitle":
    "카드 위치 확인 패널의 카드와 핸드 히스토리 카드가 다릅니다",
  "aiSetup.cardsOnlyInImage": "이미지에만 있는 카드: {cards}",
  "aiSetup.cardsOnlyInHandHistory": "핸드 히스토리에만 있는 카드: {cards}",
  "aiSetup.cardMismatchHelp":
    "텍스트 보기에서 JSON의 카드를 고치거나, 박스가 빠졌다면 카드 위치 확인 패널에서 박스를 추가해 주세요.",
  "aiSetup.openTextView": "텍스트 보기로 전환",
  "aiSetup.editorPlaceholder":
    "OHH JSON 또는 Bracketed Text 핸드 히스토리를 붙여넣으세요...",
  "aiSetup.prettifyJson": "JSON 정리",
  "aiSetup.convertedBeforeValidation":
    "검증 전에 {format}을 OHH JSON으로 변환했습니다.",
  "aiSetup.forPlayers": "대상: {players}",
  "aiSetup.viewOriginal": "원문 보기",
  "aiSetup.applyToSolver": "솔버에 적용",
  "aiSetup.applyDescription":
    "솔버의 보드, 프리플랍 기반 레인지, 팟, 유효 스택을 설정합니다.",
  "aiSetup.simplifyRanges": "실전적인 빈도로 단순화(0%, 25%, 50%, 75%, 100%)",
  "aiSetup.simplifyRangesHelp":
    "테이블에서 실행하기 쉽습니다. 원래 빈도가 더 정밀하지만 솔브 시간이 더 깁니다.",
  "aiSetup.addHandFirst": "먼저 2단계에 핸드 히스토리를 추가하세요.",
  "aiSetup.solving": "솔브 중...",
  "aiSetup.applyConfig": "설정 적용",
  "aiSetup.iterationProgress": "반복 {current} / {target}",
  "aiSetup.exploitabilityShort": "(익스플로잇: {value})",
  "aiSetup.solveProgress": "솔브 진행률",
  "aiSetup.preflopOnlyTitle": "프리플랍 전용 핸드 감지",
  "aiSetup.preflopOnlyHelp":
    "‘설정 적용’을 누르면 이 핸드의 프리플랍 액션만 분석합니다. 프리플랍에서 끝난 핸드는 솔버 설정을 만들 수 없습니다.",
  "aiSetup.chips": "칩",
  "aiSetup.jsonFormatError": "JSON 형식 오류: 유효하지 않은 JSON입니다.",
  "aiSetup.imageOnly": "이미지 파일(PNG, JPG)만 분석할 수 있습니다.",
  "aiSetup.parsingImage": "AI로 이미지를 분석하는 중...",
  "aiSetup.imageParsed":
    "이미지를 분석했습니다. 핸드 히스토리 JSON을 검토하고 ‘설정 적용’을 누르세요.",
  "aiSetup.imageParseFailed": "이미지를 분석하지 못했습니다",
  "aiSetup.unexpectedError": "예기치 않은 오류가 발생했습니다",
  "aiSetup.unknownError": "알 수 없는 오류",
  "aiSetup.unknownStringError": "알 수 없는 문자열 오류",
  "aiSetup.unknownObjectError": "알 수 없는 객체 오류",
  "aiSetup.errorPrefix": "오류: {message}",
  "aiSetup.sampleLoadFailed":
    "샘플을 불러오지 못했습니다: 콘텐츠를 찾을 수 없습니다({filename})",
  "aiSetup.sampleLoaded":
    "샘플 핸드 히스토리를 입력했습니다({filename}). ‘설정 적용’을 누르세요.",
  "aiSetup.parseFailed": "핸드 히스토리를 분석하지 못했습니다:\n{detail}",
  "aiSetup.unsupportedFormat":
    "OHH JSON 및 {formats} 형식만 지원합니다. 지원 형식을 붙여넣거나 이미지를 업로드해 분석하세요.",
  "aiSetup.ohhValidationFailed": "OHH 검증에 실패했습니다:\n{errors}",
  "aiSetup.unknownParsingError": "알 수 없는 분석 오류",
  "aiSetup.unknownStartingStack":
    "설정을 적용할 수 없습니다. {players}의 시작 스택을 알 수 없습니다(-1). 핸드 히스토리 JSON에 각 플레이어의 starting_stack을 입력하세요.",
  "aiSetup.invalidHandState": "유효하지 않은 핸드 상태입니다",
  "aiSetup.missingOhh":
    "OHH JSON을 읽지 못해 프리플랍 분석을 진행할 수 없습니다.",
  "aiSetup.preflopOnlyDetected":
    "프리플랍 전용 핸드입니다. 아래에 액션 타임라인을 표시합니다.",
  "aiSetup.preflopAnalysisFailed":
    "프리플랍 핸드를 분석하지 못했습니다. 핸드 히스토리 형식을 확인하세요.",
  "aiSetup.missingSummary": "OHH 요약 정보가 없어 설정을 적용할 수 없습니다.",
  "aiSetup.rangeLoaded": "(레인지 불러옴)",
  "aiSetup.defaultRange": "(기본 레인지)",
  "aiSetup.configApplied":
    "설정을 적용했습니다!\n보드: {board}\n팟: {pot} | 유효 스택: {stack}\nOOP: {oopPosition} {oopRangeStatus}\nIP: {ipPosition} {ipRangeStatus}",
  "aiSetup.rangeQuality": "레인지 품질:",
  "aiSetup.defaultBetSizes": "벳 사이즈: 33%, 50%, 75%(기본)",
  "aiSetup.noMessage": "{name}(메시지 없음)",
  "aiSetup.unknownNoMessage": "알 수 없는 오류(메시지 없음)",
  "aiSetup.editFailed": "편집 실패: {message}",
  "aiSetup.playerNotFound": "{seat}번 좌석의 플레이어를 찾을 수 없습니다",
  "aiSetup.normalizedInvalid":
    "정규화한 핸드 히스토리가 유효한 OHH JSON이 아닙니다.",
  "aiSetup.reachingRangesFailed":
    "도달 레인지를 가져오지 못했습니다: {message}",
  "aiSetup.actionFrequency": " → {action} 빈도",
  "aiSetup.rangeMetadata":
    "{label}: {player}({position}){action} - 방식: {method}",
  "aiSetup.loadRangesFailed": "레인지를 불러오지 못했습니다: {message}",
  "results.basics": "기본",
  "results.potValue": "팟 {value}",
  "results.stackValue": "스택 {value}",
  "results.total": "합계",
  "results.linkCopied": "복사했습니다!",
  "results.copyShareLink": "공유 링크 복사",
  "results.graphs": "그래프",
  "results.compare": "비교",
  "results.player": "플레이어:",
  "results.autoPlayer": "자동({player})",
  "results.barHeight": "바 높이:",
  "results.barWidth": "바 너비:",
  "results.normalized": "정규화",
  "results.absolute": "절대값",
  "results.full": "전체",
  "results.suit": "무늬:",
  "results.grouped": "그룹",
  "results.individual": "개별",
  "results.display": "표시:",
  "results.strategy": "전략",
  "results.strategyEq": "전략 + EQ",
  "results.strategyEv": "전략 + EV",
  "results.weight": "가중치",
  "results.chart": "차트:",
  "results.strategyCombos": "전략(콤보)",
  "results.strategyPercent": "전략(%)",
  "results.equity": "에퀴티",
  "results.summary": "요약",
  "results.actionPercent": "액션 %",
  "results.actionEv": "액션 EV",
  "results.exportSummary": "요약을 CSV 파일로 내보내기",
  "results.loadingCachedTree": "캐시된 트리를 불러오는 중...",
  "results.solverNotRun": "솔버를 실행하지 않았습니다.",
  "results.solverRunning": "솔버 실행 중...",
  "results.finalizing": "마무리 중...",
  "results.solverPaused": "솔버가 일시정지됐습니다.",
  "results.treePreview":
    "트리 구조 보기 — 솔브를 시작하지 않았습니다. 솔버 실행 후 전략 데이터가 표시됩니다.",
  "results.backToSolver": "솔버로 돌아가기",
  "results.gtoScore": "GTO 점수",
  "sideBar.oopRange": "OOP 레인지",
  "sideBar.ipRange": "IP 레인지",
  "sideBar.board": "보드",
  "sideBar.treeConfiguration": "트리 설정",
  "sideBar.runSolver": "솔버 실행",
  "sideBar.result": "결과",
  "sideBar.about": "소개",
  "sideBar.ranges": "레인지",
  "sideBar.solve": "솔브",
  "sideBar.playerRanges": "플레이어 레인지",
  "sideBar.solver": "솔버",
  "sideBar.menu": "메뉴",
  "aiSetup.annotationsRegions": "영역",
  "aiSetup.annotationsCards": "카드",
  "aiSetup.annotationsWords": "단어",
  "aiSetup.annotatedPreview": "주석이 표시된 미리보기",
  "aiSetup.sourceImage": "원본 이미지",
  "aiSetup.extractionResultSummary": "이미지 영역과 추출 요약",
  "aiSetup.viewExtractionResult": "추출 결과 보기",
  "aiSetup.hideExtractionResult": "추출 결과 접기",
  "aiSetup.extractedImageDetails": "이미지 추출 세부 정보",
  "aiSetup.extractionSummary": "추출 요약",
  "aiSetup.stageWithPotSize": "{stage} (팟사이즈 {amount})",
  "aiSetup.board": "보드",
  "aiSetup.players": "플레이어",
  "aiSetup.extractedRegions": "추출 영역",
  "aiSetup.noPreflopStrategy": "불러온 프리플랍 전략이 없습니다",
  "aiSetup.preflopTreeHelp":
    "AI 셋업에서 핸드를 적용하면 솔브한 프리플랍 트리가 여기에 표시됩니다.",
  "aiSetup.goToAiSetup": "AI 셋업으로 이동",
  "aiSetup.selectTreePosition": "전략을 보려면 트리에서 포지션을 선택하세요",
  "aiSetup.actions": "액션",
  "aiSetup.combo": "콤보",
  "aiSetup.postflopConfig": "포스트플랍 설정",
  "aiSetup.notSet": "미설정",
  "aiSetup.advanced": "고급",
  "aiSetup.pot": "팟",
  "aiSetup.stack": "스택",
  "aiSetup.editSettings": "설정 편집",
  "aiSetup.continueToSolver": "솔버로 이동",
  "aiSetup.selectPosition": "포지션 선택",
  "aiSetup.positionStrategy": "{position} 전략",
  "aiSetup.workflowLabel": "AI 셋업 작업 흐름",
  "aiSetup.workflow": "작업 흐름",
  "aiSetup.strategyLoaded": "전략 불러옴",
  "aiSetup.setup": "설정",
  "aiSetup.solve": "솔브",
  "aiSetup.preflopActionTree": "프리플랍 액션 트리",
  "aiSetup.revert": "되돌리기",
  "aiSetup.pokerStarsTextLabel": "PokerStars 핸드 히스토리 텍스트",
  "aiSetup.lineIssue": "{line}행: ",
  "aiSetup.pokerStarsCopied": "PokerStars 텍스트를 클립보드에 복사했습니다.",
  "aiSetup.pokerStarsCopyFailed": "PokerStars 텍스트를 복사하지 못했습니다.",
  "aiSetup.resetBoxes": "초기화",
  "aiSetup.pokerStarsEditFailed":
    "수정을 적용하지 못했습니다 · 아래 줄 문제를 고쳐 주세요",
  "aiSetup.pokerStarsShownInBbExportChips":
    "BB로 표시합니다. 복사와 다운로드는 칩 단위입니다 · 수정하면 바로 적용됩니다",
  "aiSetup.pokerStarsShownInBb": "BB로 표시합니다 · 수정하면 바로 적용됩니다",
  "aiSetup.ruleErrorsTitle": "핸드 규칙 오류 {count}건",
  "aiSetup.pokerStarsExportBlockedByRuleErrors":
    "핸드 규칙 오류를 고치면 내보낼 수 있습니다.",
  "aiSetup.pokerStarsExportIssue":
    "{message}. 화면의 텍스트는 표시용 BB 단위라 원래 칩 금액과 다릅니다.",
  "aiSetup.pokerStarsExportsChips": "칩 단위 PokerStars 텍스트로 내보냅니다",
  "aiSetup.pokerStarsExports": "PokerStars 텍스트로 내보냅니다",
  "aiSetup.pokerStarsEditing": "수정 중 · 입력이 끝나면 핸드에 자동 반영됩니다",
  "aiSetup.pokerStarsReady": "수정하면 바로 적용됩니다",
  "aiSetup.pokerStarsUnsupported":
    "OHH JSON과 지원하는 형식의 텍스트만 변환할 수 있습니다.",
  "aiSetup.pokerStarsParseFailed":
    "핸드 히스토리를 분석하지 못했습니다: {detail}",
  "aiSetup.pokerStarsInvalidOhh": "유효하지 않은 OHH JSON입니다: {detail}",
  "aiSetup.pokerStarsConversionFailed":
    "PokerStars 텍스트로 변환할 수 없습니다: {detail}",
  "aiSetup.reviewCardPositions": "카드 위치 확인하기",
  "aiSetup.cardPositionReview": "카드 위치 확인",
  "aiSetup.collapse": "접기",
  "aiSetup.cardPositionImage": "카드 위치 확인 이미지",
  "aiSetup.addBoxInstruction": "박스 추가 중 — 카드를 감싸도록 드래그하세요",
  "aiSetup.done": "완료",
  "aiSetup.aiPrediction": "AI 예측",
  "aiSetup.userEdited": "내가 수정·추가",
  "aiSetup.unassignedCard": "카드 미지정",
  "aiSetup.aspectMismatch":
    "이미지 비율이 감지 결과와 달라 자동 감지를 쓸 수 없습니다. 보이는 카드를 직접 표시해 주세요.",
  "aiSetup.noDetectionResult":
    "자동 감지 결과가 없습니다. 보이는 카드를 직접 표시해 주세요.",
  "aiSetup.noCardsDetected": "감지된 카드 없음",
  "aiSetup.addingBox": "박스 추가 중",
  "aiSetup.addBox": "박스 추가",
  "aiSetup.undo": "실행 취소",
  "aiSetup.resetToPrediction": "AI 예측으로 되돌리기",
  "aiSetup.resetPredictionLabel": "AI 예측으로 되돌리기 확인",
  "aiSetup.resetPredictionConfirm":
    "내 수정 내용을 지우고 AI 예측으로 되돌리시겠습니까?",
  "aiSetup.unassigned": "미지정",
  "aiSetup.selectCardBox": "카드 {card} 박스 선택",
  "aiSetup.changeCard": "카드 변경",
  "aiSetup.missingCardHelp":
    "AI가 찾지 못한 카드가 있을 수 있습니다. 화면 전체를 보고 빠진 카드에 박스를 추가해 주세요.",
  "aiSetup.submitting": "제출 중…",
  "aiSetup.submitTrainingData": "학습 데이터로 제출",
  "aiSetup.tryAgain": "다시 시도",
  "aiSetup.noDetectionSummary":
    "자동 감지 결과 없음 · 카드 위치를 직접 표시해 주시면 카드 인식 개선에 쓰입니다",
  "aiSetup.detectionSummary":
    "카드 {count}장 감지 · 확인해 주시면 카드 인식 개선에 쓰입니다",
  "aiSetup.confirmNoCards": "이 이미지에 보이는 카드가 없음을 확인했습니다",
  "aiSetup.confirmAllCards":
    "이미지에 보이는 모든 카드에 박스를 표시하고 카드를 확인했습니다",
  "aiSetup.unassignedCount": "카드 미지정 박스 {count}개",
  "aiSetup.tooSmallCount": "너무 작은 박스 {count}개",
  "aiSetup.duplicateCount": "겹친 박스 {count}쌍",
  "aiSetup.tooManyBoxes": "박스는 64개까지",
  "aiSetup.invalidBoxes":
    "박스 정보가 유효하지 않습니다 — 초기화한 뒤 다시 표시해 주세요",
  "aiSetup.submissionSuccess":
    "제출했습니다. 다시 고쳐 제출하면 최신 내용으로 바뀝니다.",
  "aiSetup.submissionStale": "제출 후 수정됨 — 다시 제출해 주세요",
  "aiSetup.submissionFailed":
    "제출하지 못했습니다. 수정 내용은 그대로 남아 있습니다.",
  "aiSetup.handHistoryUpdated": "핸드 히스토리에 반영: {summary}",
  "aiSetup.handHistoryReverted": "핸드 히스토리 되돌림: {summary}",
  "dbItemPicker.noSavedRanges": "(저장된 레인지 없음)",
  "dbItemPicker.noSavedConfigurations": "(저장된 설정 없음)",
  "dbItemPicker.emptyGroup": "(빈 그룹)",
  "dbItemPicker.loadError": "문제가 발생했습니다. 페이지를 새로고침해 주세요.",
  "dbItemPicker.load": "불러오기",
  "dbItemPicker.overwrite": "덮어쓰기",
  "dbItemPicker.rename": "이름 변경",
  "dbItemPicker.addGroup": "그룹 추가",
  "dbItemPicker.importJson": "JSON 가져오기",
  "dbItemPicker.exportJson": "JSON 내보내기",
  "dbItemPicker.importFailed": "오류: 가져오기에 실패했습니다.",
  "dbItemPicker.newGroup": "새 그룹",
  "dbItemPicker.newRange": "새 레인지",
  "dbItemPicker.newConfiguration": "새 설정",
  "dbItemPicker.groupConflict":
    '항목이 이미 있어 "{name}" 그룹을 만들 수 없습니다',
  "login.tagline": "진지한 플레이어를 위한",
  "login.seriousPlayers": "GTO 포커 솔버",
  "login.postflopSolver": "포스트플랍 솔버",
  "login.preflopSolutions": "프리플랍 솔루션",
  "login.createAccount": "계정 만들기",
  "login.signIn": "로그인",
  "login.signUpGoogle": "Google로 가입",
  "login.continueGoogle": "Google로 계속",
  "login.signUpApple": "Apple로 가입",
  "login.continueApple": "Apple로 계속",
  "login.oauthHelp":
    "OAuth는 Google 또는 Apple을 통해 계정을 만들며 Locktree 비밀번호를 설정하지 않습니다.",
  "login.createWithEmail": "또는 이메일과 비밀번호로 가입",
  "login.signInWithEmail": "또는 이메일로 로그인",
  "login.email": "이메일",
  "login.emailPlaceholder": "you@example.com",
  "login.password": "비밀번호",
  "login.confirmPassword": "비밀번호 확인",
  "login.confirmPasswordPlaceholder": "비밀번호를 다시 입력하세요",
  "login.resendVerification": "인증 이메일 다시 보내기",
  "login.processing": "처리 중...",
  "login.haveAccount": "이미 계정이 있나요? 로그인",
  "login.needAccount": "계정이 없나요? 계정 만들기",
  "login.passwordMismatch": "비밀번호가 일치하지 않습니다",
  "login.passwordRequirements": "비밀번호 요구사항을 충족하지 않습니다",
  "login.accountCreated":
    "계정을 만들었습니다. 로그인하기 전에 이메일을 확인하세요.",
  "login.verificationSent": "인증 이메일을 보냈습니다.",
  "history.title": "솔브 히스토리",
  "history.loading": "히스토리를 불러오는 중...",
  "history.signInHelp": "솔브 히스토리를 보려면 로그인하세요",
  "history.empty": "아직 솔브 히스토리가 없습니다",
  "history.emptyHelp": "솔버를 실행하면 솔브한 트리가 여기에 표시됩니다",
  "history.invalidEntries.one": "유효하지 않은 항목 {count}개 발견",
  "history.invalidEntries.other": "유효하지 않은 항목 {count}개 발견",
  "history.invalidHelp":
    "버그 수정 이전의 데이터가 누락되거나 손상된 항목입니다",
  "history.deleteAllInvalid": "유효하지 않은 항목 모두 삭제",
  "history.unnamed": "이름 없음",
  "history.invalidData": "유효하지 않은 데이터",
  "history.configOnly": "설정만 저장됨",
  "history.loadingConfig": "설정 불러오는 중...",
  "history.noBoard": "보드 없음",
  "history.exploitability": "익스플로잇 가능성: {value}",
  "history.iterations": "반복: {value}",
  "history.manual": "수동",
  "history.loadMore": "더 불러오기({shown} / {total})",
  "history.deleteEntry": "항목을 삭제할까요?",
  "history.deleteConfirm": '"{name}"을(를) 삭제할까요?',
  "history.deleteInvalidConfirm":
    "유효하지 않은 항목 {count}개를 삭제할까요? 이 작업은 되돌릴 수 없습니다.",
  "history.deleteSomeFailed":
    "일부 항목을 삭제하지 못했습니다. 다시 시도해 주세요.",
  "history.loadFailed": "히스토리를 불러오지 못했습니다",
  "history.configLoaded":
    "이전 설정을 불러왔습니다. 보드와 레인지를 확인한 후 다시 솔버를 실행하세요.",
  "history.configLoadFailed":
    "설정을 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.",
  "handHistory.handNumber": "핸드 #{id}",
  "handHistory.ante": "앤티:",
  "handHistory.players": "플레이어",
  "handHistory.stack": "스택",
  "handHistory.board": "보드:",
  "handHistory.actionAmount": "액션 금액({unit})",
  "handHistory.deleteAction": "액션 삭제",
  "handHistory.addAction": "+ 액션 추가",
  "handHistory.summary": "요약",
  "handHistory.totalPot": "총 팟:",
  "handHistory.finalBoard": "최종 보드:",
  "handHistory.unavailable": "핸드 히스토리가 없습니다",
  "handHistory.allIn": "올인",
  "handHistory.noLimit": "노리밋",
  "handHistory.potLimit": "팟 리밋",
  "handHistory.fixedLimit": "픽스드 리밋",
  "handHistory.unspecified": "미지정",
  "handHistory.street": "스트리트 {street}",
  "handHistory.unknown": "알 수 없음",
  "handHistory.postsSb": "SB 포스트",
  "handHistory.postsBb": "BB 포스트",
  "handHistory.postsAnte": "앤티 포스트",
  "handHistory.folds": "폴드",
  "handHistory.checks": "체크",
  "handHistory.calls": "콜",
  "handHistory.bets": "벳",
  "handHistory.raises": "레이즈",
  "handHistory.shows": "공개",
  "handHistory.mucks": "머크",
  "handHistory.collected": "팟 획득",
  "handHistory.doesNotShow": "카드 비공개",
  "handHistory.sampleTitle": "샘플 핸드 히스토리 선택",
  "handHistory.imageUnavailable": "이미지를 사용할 수 없습니다",
  "score.title": "GTO 점수 분석",
  "score.decisionsAnalyzed": "결정 {count}개 분석",
  "score.totalEvLoss": "총 EV 손실: -{value}bb",
  "score.hero": "히어로:",
  "score.points": "{points}점",
  "score.experience": "체험하기",
  "score.noDecisions": "분석할 히어로 결정이 없습니다",
  "score.calculating": "GTO 점수 계산 중...",
  "score.noHandHistory": "분석할 핸드 히스토리가 없습니다",
  "spot.evLoss": "EV 손실 -{value} BB",
  "spot.analyzing": "분석 중...",
  "spot.actualOpponentHand": "상대 실제 핸드",
  "spot.opponentRange": "상대 레인지 분포",
  "spot.value": "밸류",
  "spot.semiBluff": "세미블러프",
  "spot.bluff": "블러프",
  "spot.gtoAnswer": "GTO 정답",
  "spot.choiceFrequency":
    "선택한 액션({action})의 GTO 빈도는 {frequency}%입니다",
  "spot.selectedActionEv": "선택한 액션 EV",
  "spot.bestActionEv": "최선 액션 EV",
  "spot.retryCount": "재시도 {count}회",
  "spot.retrySame": "같은 스팟 다시 하기",
  "spot.noUploadedHand": "업로드된 핸드 히스토리가 없습니다.",
  "spot.analysisFailed": "분석에 실패했습니다.",
  "spot.retryFailed": "재시도에 실패했습니다.",
  "spot.networkError": "네트워크 오류",
  "spot.error": "오류: {message}",
  "results.graphsUnavailable": "그래프를 사용할 수 없습니다",
  "results.wins": "{player} 승리",
  "preflopTree.actualPlay": "실제 플레이",
  "preflopTree.postflopStarts": "포스트플랍 시작",
  "preflopTree.headsUpOnly": "헤즈업만 포스트플랍 솔브를 지원합니다",
  "preflopTree.terminalHeader": "종료",
  "preflopTree.flopHeader": "플랍",
  "preflopTree.turnHeader": "턴",
  "preflopTree.riverHeader": "리버",
  "preflopTree.flopBoard": "플랍 보드",
  "preflopTree.cardPlaceholder": "예: 9s",
  "preflopTree.running": "실행 중...",
  "preflopTree.runPostflop": "포스트플랍 솔브 실행",
  "preflopTree.actionTree": "액션 트리",
  "preflopTree.selectNode": "레인지를 보려면 노드를 선택하세요",
  "preflopTree.handEnds": "핸드 종료",
  "preflopTree.enterThreeCards": "카드 3장을 모두 입력하세요.",
  "preflopTree.invalidCard":
    '{position} 번째 카드가 유효하지 않습니다: "{card}"',
  "preflopTree.first": "첫",
  "preflopTree.second": "두",
  "preflopTree.third": "세",
  "preflopTree.duplicateCards": "중복 카드가 있습니다.",
  "preflopTree.reachingRangesMissing":
    "도달 레인지를 사용할 수 없습니다. 프리플랍 솔브를 먼저 완료하세요.",
  "preflopTree.resultIdMissing":
    "포스트플랍 솔브 결과 식별자를 받지 못해 결과를 불러올 수 없습니다.",
  "preflopTree.runFailed": "포스트플랍 솔브 실행 실패",
  "preflopSettings.change": "변경",
  "preflopSettings.format": "형식",
  "preflopSettings.formatCash": "캐시",
  "preflopSettings.formatMtt": "MTT",
  "preflopSettings.anteBigBlind": "BB 앤티 1bb",
  "preflopSettings.antePerSeat": "좌석당 앤티 0.125bb",
  "preflopSettings.ante": "앤티",
  "preflopSettings.players": "플레이어",
  "preflopSettings.stack": "스택(BB)",
  "preflopSettings.solve": "솔브",
  "preflopSolution.root": "루트",
  "preflopSolution.exploitabilityShort": "expl: {value}",
  "preflopSolution.exploitability": "익스플로잇 가능성: {value}",
  "preflopSolution.cacheTime": "캐시 저장 시각: {value}",
  "preflopSolution.cache": "캐시: {value}",
  "preflopSolution.unavailable": "사전계산 전략을 사용할 수 없습니다",
  "preflopSolution.unavailableHelp":
    "이 프리플랍 스팟은 아직 사전계산되지 않았습니다. 다른 설정을 선택하거나 다음 사전계산 배치 후 다시 시도하세요.",
  "preflopStrategy.solveToView": "전략을 보려면 솔브하세요",
  "preflopStrategy.combos": "{count} 콤보",
  "preflopStrategy.comingSoon": "준비 중",
  "preflopStrategy.strategy": "전략",
  "preflopStrategy.range": "레인지",
  "preflopStrategy.analysis": "분석",
  "preflopStrategy.report": "리포트",
  "preflopOverview.potOdds": "팟 오즈:",
  "preflopOverview.actions": "액션",
  "preflopOverview.filterByAction": "액션으로 필터링",
  "preflopOverview.minimumFrequency": "최소 빈도: {frequency}%",
  "preflopOverview.handCount.one": "{count}핸드",
  "preflopOverview.handCount.other": "{count}핸드",
  "preflopOverview.handsMatching": "조건에 맞는 핸드 {count}개",
  "preflopOverview.blockerHelp":
    "블로커 분석에는 포스트플랍 정보가 필요합니다. 블로커 효과를 보려면 포스트플랍 스팟을 선택하세요.",
  "preflopOverview.solveToView": "개요를 보려면 솔브하세요",
  "preflopOverview.hand": "핸드",
  "preflopOverview.solveToViewTable": "표를 보려면 솔브하세요",
  "preflopOverview.equityDistribution": "{position}의 액션별 에퀴티 분포",
  "preflopOverview.combo": "콤보",
  "preflopOverview.solveToViewEquity": "에퀴티 차트를 보려면 솔브하세요",
  "preflopOverview.overview": "개요",
  "preflopOverview.table": "표",
  "preflopOverview.equityChart": "에퀴티 차트",
  "preflopOverview.summary": "요약",
  "preflopOverview.filter": "필터",
  "preflopOverview.blocker": "블로커",
  "preflopOverview.actionEv": "액션별 EV (bb)",
  "trace.recordedNev": "기록된 NEV to hero (액션)",
  "trace.terminalPath": "터미널 경로",
  "trace.neutralFallback":
    "중립 대체값이 사용된 경로입니다. 실제 사용 에퀴티를 측정된 원시 에퀴티로 해석하지 마세요.",
  "trace.legacyFallback":
    "이전 세대 산출물입니다. 학습 정책이 7인 이상 멀티웨이 에퀴티 계산을 생략하고 중립 대체값 (1/N)을 사용한 경로입니다. 실제 사용 에퀴티를 측정된 원시 에퀴티로 해석하지 마세요.",
  "trace.unrecordedDecomposition":
    "최종 EV만 기록된 계산 경로입니다. 상대별 에퀴티 분해는 미기록입니다.",
  "trace.threeWayHelp":
    "3-way 조건부 평균입니다. 각 행은 상대 1의 핸드를 고정하고 상대 2의 레인지를 합친 값입니다. 세 플레이어의 에퀴티 × ERW를 튜플마다 정규화한 지분이며, HU 승률이나 양쪽 ERW만의 비율이 아닙니다. 유효 조합 열에는 상대 2의 도달 확률이 포함된 조합 질량을 표시합니다. 튜플별 분모는 미기록이므로 이 표만으로 개별 분모를 검산할 수 없습니다.",
  "trace.hand169Help":
    "실제 수트 콤보가 아닌 Hand169 클래스입니다. 상대 핸드를 누르면 표를 필터링합니다.",
  "trace.terminalTableCaption":
    "상대 핸드별 원시 에퀴티, ERW, 정규화 지분 및 히어로 값 기여",
  "trace.reach": "도달 확률",
  "trace.reachValue": "도달 확률 {value}",
  "trace.depthValue": "깊이 {depth}",
  "trace.rawEquity": "원시 에퀴티",
  "trace.potShare": "팟 지분",
  "trace.terminalContribution": "터미널 내부 기여 bb",
  "trace.sidePotHelp":
    "사이드팟별 기존 레인지 집계입니다. 총액을 모두 합친 뒤 기여금과 앤티를 한 번만 차감합니다.",
  "trace.pot": "팟",
  "trace.providerStatus": "프로바이더 상태",
  "trace.usedEquity": "사용 에퀴티",
  "trace.grossBb": "총액 bb",
  "trace.seatHandPot": "좌석 · 핸드 · 팟",
  "trace.usedPositionRank": "사용 포지션 순위",
  "trace.ruleBasedHelp":
    "수딧 & 커넥터 보정값 × 포지션 효과 × 공격자 레인지 효과 = 프리미엄 보정 전 ERW(B). SPR 보정 전 ERW(E) = B + (1.09482872 − B) × 프리미엄 복원 강도이며, 1.09482872는 가장 IP인 좌석이 동시에 마지막 공격자일 때의 ERW로 이 모델의 상계입니다. 프리미엄 복원 강도는 핸드별 등급이며, 위 표에 보이는 값이 이 호출에서 실제 사용한 값입니다. 계수 세대에 따라 달라지므로 문서의 등급표와 대조하지 마세요. SPR 복원 강도 = 1 / (1 + (SPR / 1.5)^2.5). 최종 ERW = E + (1 − E) × SPR 복원 강도입니다.",
  "trace.offsetHelpBeforeFormula":
    "측정 경로의 값은 좌석별 실현 오프셋(팟 비율)입니다. 측정 포스트플랍 솔브에서 이 핸드가 같은 보드의 쇼다운 에퀴티보다 팟을 얼마나 더(+) 또는 덜(−) 가져갔는지를 측정 레인지의 주변분포를 재현하도록 푼 값입니다. 규칙 기반 합성식(곱셈·프리미엄·SPR 복원)과 팟 성장 변환을 쓰지 않습니다. 딜의 지분은",
  "trace.offsetHelpAfterFormula":
    "이며 e는 그 딜의 물리 에퀴티, δ는 두 좌석의 실현 오프셋입니다. 0 미만 지분은 포스트플랍 추가 투입 손실입니다.",
  "trace.offsetFormulaSuffix": "로 정해집니다 —",
  "trace.erwCaution":
    "공격자 레인지 효과는 마지막 공격자 여부를 이용한 근사입니다. 규칙 기반 ERW는 확률이 아닌 배율이고, 측정 경로의 값은 팟 비율 오프셋입니다. 어느 쪽이든 현재 호출에서 기록한 값입니다. 산출값 기록은 payoff에 실제 반영되었다는 보장이 아닙니다. 프로바이더 상태를 함께 확인하세요.",
  "trace.opponentSeatPot": "상대 좌석 · 팟",
  "trace.poolingHelp":
    "Z=포함 질량, B=Σ(질량×사용 에퀴티), A=Σ(질량×사용 에퀴티×ERW). 포함된 좌석들의 Σ(A/Z) ÷ Σ(B/Z)가 상대 평균 ERW입니다. DeadReach 등 제외 상태는 아래 입력에 남습니다.",
  "trace.root": "루트",
  "trace.actingSeatHidden": "acting 좌석 기준 — 이 핸드 관점이 아니라 숨김",
  "trace.firstIteration": "첫 반복으로 이동",
  "trace.previousIteration": "이전 반복으로 이동",
  "trace.nextIteration": "다음 반복으로 이동",
  "trace.lastIteration": "마지막 반복으로 이동",
  "trace.searchPlaceholder":
    "포지션 / 액션 / node_key 검색 — 예: UTG+2, allin, r22r52",
  "trace.explorerTitle": "CFR 노드 탐색기",
  "trace.runSummary": "{players}인 · 캡처 {nodes} · {hands} · {interval}",
  "trace.noLocation":
    "선택한 트레이스가 없습니다. 프리플랍 솔루션 화면에서 핸드를 선택한 뒤 학습 트레이스를 열면 이 화면으로 들어옵니다.",
  "trace.hand": "핸드",
  "trace.first": "처음",
  "trace.previous": "이전",
  "trace.iteration": "iteration {iteration}",
  "trace.perspective": "관점",
  "trace.next": "다음",
  "trace.last": "마지막",
  "trace.learningTurnNotice":
    "학습 좌석: {iterationSeat} — {actingSeat} 좌석은 이 회차에 갱신되지 않았습니다",
  "trace.previousLearning": "← {seat} 이전 학습 회차",
  "trace.nextLearning": "{seat} 다음 학습 회차 →",
  "trace.expandDepth": "깊이 {depth}까지",
  "trace.expandAll": "모두 펴기",
  "trace.collapseAll": "모두 접기",
  "trace.followWorstPath": "손실 경로 따라가기",
  "trace.rowCount": "트레이스 {visible} / {total}행",
  "trace.refreshing": "갱신 중…",
  "trace.nodeTitle": "{seat} 노드로 이동",
  "trace.uncaptured": "캡처 범위 밖 (이 회차 값 없음)",
  "trace.toggle": "접고 펴기",
  "trace.evidenceAria": "{action} hero 값 계산 근거 보기",
  "trace.evidence": "근거",
  "trace.allHands": "모든 핸드",
  "trace.heroTraining": "hero 학습",
  "trace.round": "회차",
  "trace.every": "{unit} {count}회마다",
  "trace.allIntervals": "{unit} 전부",
  "trace.noTraceForGame": "이 판에는 학습 트레이스가 없습니다",
  "trace.loadingTrace": "학습 트레이스를 불러오는 중…",
  "trace.loadTraceFailed": "학습 트레이스를 불러오지 못했습니다.",
  "trace.selectHandFirst": "핸드를 먼저 고르세요",
  "trace.notCaptured": "이 지점은 이 핸드로 기록되지 않았습니다",
  "trace.columnTreePosition": "노드/액션 정보",
  "trace.columnLearningInput": "학습 데이터",
  "trace.columnLearningApplied": "학습 후",
  "trace.stageLearningInput": "그 회차 학습을 만든 값 (학습 데이터)",
  "trace.stageLearningApplied": "그 회차 학습이 반영된 값 (학습 후)",
  "trace.columnTooltipStage": "{description} — {stage}",
  "trace.columnAction": "액션 (포지션)",
  "trace.columnDepth": "깊이",
  "trace.columnRegret": "regret",
  "trace.columnActionHelp":
    "그 노드에서 뻗는 액션 하나와 그 액션을 하는 좌석입니다. 들여쓰기가 깊이를 나타냅니다.",
  "trace.columnDepthHelp":
    "루트부터 이 엣지가 출발하는 노드까지 이미 일어난 액션 수입니다. 지금 보는 노드가 기준이 아니라 루트 기준 절대 깊이입니다.",
  "trace.columnRegretBefore": "regret sum (전)",
  "trace.columnRegretBeforeHelp":
    "그 회차가 시작될 때 이 액션이 이미 갖고 있던 누적 regret입니다. 이전 회차까지 쌓인 값이라 이번 순회가 만든 것이 아닙니다. 이 값의 양수 몫이 그 좌석의 이번 회차 액션 확률을 만들었습니다. regret sum (후) − regret로 되돌린 파생값입니다. 상대가 행동하는 행에서는 비웁니다. acting 좌석이 이 행의 Hand169를 들었을 때의 값이라 이 핸드를 따라가는 화면에서는 대표성이 없습니다.",
  "trace.columnReachHelp": "그 행의 기준 player가 여기까지 올 확률입니다.",
  "trace.columnNodeNev": "NEV to hero (노드)",
  "trace.columnNodeNevHelp":
    "이 핸드가 그 노드에서 얻는 기대값(bb)입니다. 자식 액션의 값을 그 회차 전략으로 섞은 값입니다. 상대가 행동하는 노드에서도 기준은 hero입니다.",
  "trace.columnActionNev": "NEV to hero (액션)",
  "trace.columnActionNevHelp":
    "이 액션이 일어났을 때 hero 핸드에게 돌아가는 기대값(bb)입니다. 액션 주체는 hero일 수도 상대일 수도 있고, 값의 귀속은 항상 hero입니다. hero가 행동하는 decision 행에서는 NEV to hero (노드)와의 차이가 regret으로 쌓입니다. 상대가 행동하는 opponent_branch 행에서는 그 회차 regret이 항상 0이라 이 관계가 성립하지 않습니다.",
  "trace.columnContribution": "기여(bb)",
  "trace.columnContributionHelp":
    "루트부터 이 엣지까지의 도달 확률 × NEV to hero (액션)입니다. 한 노드의 자식 기여를 모두 더하면 그 노드의 값이 나옵니다.",
  "trace.columnRegretHelp":
    "이번 회차가 regret sum에 더한 값입니다. decision 행에서는 NEV to hero (액션) − NEV to hero (노드)를 바탕으로 CFR 변형이 계산합니다. 상대가 행동하는 행에서는 비웁니다. 그 값은 acting 좌석 기준이고 그 좌석이 이 회차 학습자가 아니면 언제나 0이라, 이 핸드의 regret이 0인 것으로 읽히기 쉽습니다.",
  "trace.columnRegretAfter": "regret sum (후)",
  "trace.columnRegretAfterHelp":
    "이번 회차 학습까지 반영된 누적 regret입니다. 그 좌석의 다음 액션 확률이 이 값의 양수 몫으로 정해집니다. 상대가 행동하는 행에서는 비웁니다. acting 좌석이 이 행의 Hand169를 들었을 때의 값이라 이 핸드를 따라가는 화면에서는 대표성이 없습니다.",
  "trace.columnNextStrategy": "다음 액션 확률",
  "trace.columnNextStrategyHelp":
    "누적 regret의 양수 몫으로 계산한 그 좌석의 다음 iteration 액션 확률입니다(regret matching). 전부 0 이하면 균등하게 나뉩니다. 상대가 행동하는 행에서는 비웁니다. acting 좌석 기준 값입니다.",
  "trace.columnAverageStrategy": "평균 액션 확률",
  "trace.columnAverageStrategyHelp":
    "CFR이 수렴하는 대상인, 그 좌석의 회차별 액션 확률 누적 평균입니다. 레인지 그리드가 보여주는 값과 같은 기준입니다. 본인 결정 행의 액션 옆 %는 그 iteration의 현재 확률이라 이 평균과 다른 것이 정상이고, 상대가 행동하는 행의 액션 옆 %는 레인지 전체 빈도(branch weight)라 애초에 비교 대상이 아닙니다. 그 행에서는 이 열을 비웁니다. acting 좌석 기준 값입니다.",
  "trace.legendPathHelp":
    "이 노드까지 온 경로입니다. action_history를 풀어 쓴 표기라 그 iteration의 값은 없고, 누르면 그 노드로 이동합니다. 레이즈 크기는 저장될 때 0.1bb 단위로 버림되므로 하한입니다. 엣지 행의 raise_2.25를 경로가 raise_2.2로 보여주는 것은 그 자리에 남은 정밀도가 거기까지라는 뜻입니다.",
  "trace.legendOpponentNode": "상대 노드",
  "trace.legendOpponentNodeHelp":
    "상대가 행동하는 노드의 행입니다. 상대가 그 액션을 했을 때 이 핸드가 얻는 값을 보여줍니다. 값 열은 hero 기준만 표시합니다. 액션 옆 %, NEV to hero, 기여(bb)는 이 핸드를 조건으로 한 상대 레인지 전체의 빈도(branch weight)라 이 핸드가 실제로 마주한 값입니다. acting 좌석 기준 열(regret sum (전/후), regret, 다음 액션 확률, 평균 액션 확률)은 비웁니다. 그 값은 acting 좌석이 이 행의 Hand169를 들었을 때의 학습 상태라 상대 레인지 169 중 한 슬라이스이고, 이 핸드를 쥐고 있어 legal combo 질량이 blocker로 줄어든 조합입니다. 값이 없는 것이 아니라 이 화면의 기준으로 대표성이 없어 0으로 채우지 않은 것이며, 그 회차의 정확한 snapshot은 API 응답에 그대로 남습니다.",
  "trace.uncalculated": "미계산",
  "trace.unrecorded": "미기록",
  "trace.unused": "미사용",
  "trace.yes": "예",
  "trace.no": "아니오",
  "trace.wholePot": "전체 팟",
  "trace.potNumber": "팟 {number}",
  "trace.erwEvidenceCount": "ERW 산출 근거 · {count}개",
  "trace.noErwEvidence":
    "ERW 산출 근거를 기록하지 않았습니다. 새 근거를 보려면 관측 기능을 켠 새 트레이스가 필요합니다.",
  "trace.erwSkipped": "ERW 산출 생략 — {reason}",
  "trace.reasonUnrecorded": "사유 미기록",
  "trace.activeSeats": "활성 좌석",
  "trace.effectiveStackBb": "유효 스택 bb",
  "trace.suited": "수딧",
  "trace.premium": "프리미엄 판정",
  "trace.lastAggressor": "마지막 공격자",
  "trace.noneOrUnrecorded": "없음 또는 미기록",
  "trace.notLastAggressor": "마지막 공격자 아님",
  "trace.rankHelp":
    "rank는 실제 계산에 사용한 값입니다(0=가장 OOP). 포커상 올바른 순서인지 다시 계산한 값이 아닙니다.",
  "trace.factorSuitedConnector": "수딧 & 커넥터 보정값",
  "trace.factorPosition": "포지션 효과",
  "trace.factorAggressorRange": "공격자 레인지 효과",
  "trace.factorBeforePremium": "프리미엄 보정 전 ERW",
  "trace.factorPremiumRecovery": "프리미엄 복원 강도",
  "trace.factorBeforeSpr": "SPR 보정 전 ERW",
  "trace.factorSprRecovery": "SPR 복원 강도",
  "trace.realizationOffset": "실현 오프셋(팟 비율)",
  "trace.finalErw": "최종 ERW",
  "trace.actionNevAria": "NEV to hero 계산 근거",
  "trace.nevToHero": "NEV to hero",
  "trace.heroValue": "hero 값",
  "trace.heroValueAria": "hero 값 계산 근거",
  "trace.actionEvidenceTitle": "{seat} · {hand} · {action} {value} 계산 근거",
  "trace.evidenceContext":
    "iteration {iteration} · {history} · 모든 EV는 선택 hero 관점입니다.",
  "trace.zeroProbabilityHelp":
    "액션 확률 0%와 평가 생략은 다릅니다. 가지치기하지 않은 액션은 0%여도 조건부 EV를 계산할 수 있습니다. 아래는 선택 회차의 관측값이며 최종 평균 전략의 전체 학습 이력을 설명하지 않습니다.",
  "trace.loadingEvidence": "EV 계산 근거를 불러오는 중…",
  "trace.loadEvidenceFailed": "EV 계산 근거를 불러오지 못했습니다.",
  "trace.verifiedContribution": "확인된 하위 기여 합{suffix}",
  "trace.terminalGrossSuffix": " (터미널 총액 EV)",
  "trace.recordedDifference": "차이 (기록 NEV − 합)",
  "trace.frameMismatch": "프레임 불일치 — 비교 불가",
  "trace.missingPaths": "누락 경로",
  "trace.foldComparison":
    "같은 노드 폴드 대비 NEV: {value} bb. 과거 투자금을 포함한 EV이므로 폴드 자체의 EV가 음수일 수 있습니다.",
  "trace.reconciliationSummary":
    "국소 불일치 {mismatches}건 · 노드 검사 불가 {unchecked}건 · 평가 생략 {pruned}건",
  "trace.reconciliationHelp":
    "기록된 노드와 자식 EV를 대조합니다. 전체 차이가 0이어도 서로 상쇄된 국소 차이는 남습니다. 누락 경로는 검증하지 못합니다.",
  "trace.reconciliationCaption": "노드별 EV 국소 불일치",
  "trace.path": "경로",
  "trace.check": "검사",
  "trace.recordedEv": "기록 EV",
  "trace.reconstructedEv": "재결합/하위 EV",
  "trace.differenceBb": "차이 bb",
  "trace.nodeSum": "노드 합",
  "trace.childLink": "자식 연결",
  "trace.missingEvidence":
    "계산 근거가 일부 또는 전부 미기록입니다. 과거 trace에는 이 정보가 없습니다. 누락 경로를 EV 0으로 해석하지 마세요.",
  "trace.terminalOption":
    "{history} · 가중치 {weight} · 기여 {contribution} bb",
  "trace.calculationStatus":
    "계산 상태: {status} · 프로바이더 상태 {provider} · 실제 사용 에퀴티 {equity}",
  "trace.evaluationSkipped": "평가 생략 ({reason}) · 순회 반환값 {value} bb",
  "trace.evaluated": "실제 평가",
  "trace.evaluationUnrecorded": "평가 여부 미기록",
  "trace.deadReach": "DeadReach로 0을 반환했습니다.",
  "trace.impossibleJointDeal":
    "불가능한 joint deal로 1/N 중립값을 사용했습니다.",
  "trace.erwNotApplied": "기록된 ERW 산출값은 이 payoff에 반영되지 않았습니다.",
  "trace.terminalFormula":
    "{method} · 팟 {pot} − 기여 {contribution} − 앤티 {ante}",
  "trace.equityFlow":
    "원시 에퀴티 {rawEquity} → 최종 팟 지분 {potShare} → 터미널 EV {terminalEv} bb",
  "trace.cacheSource":
    "캐시 원본 기록: iteration {iteration} · {history} · key {key}. 재계산 없이 동일 입력의 원본 측정을 연결했습니다.",
  "trace.usedEquityLabel": "사용 에퀴티",
  "trace.rawEquityLabel": "원시 에퀴티",
  "trace.equityDifference":
    "{equityLabel} 대비 최종 팟 지분 차이: {value} bb. {source} 함께 반영된 차이입니다. 그 항을 제거한 재학습 결과가 아닙니다.",
  "trace.heroRealizationOffset": "Hero 실현 오프셋(팟 비율)",
  "trace.heroErw": "Hero ERW",
  "trace.offsetDifference": "실현 오프셋 차이가",
  "trace.erwNormalization": "ERW와 정규화가",
  "trace.opponentHandInputs": "상대 {seat}의 핸드별 계산 입력",
  "trace.expandHandMatrix": "169 핸드 매트릭스 펼치기",
  "trace.showAllOpponentHands": "전체 상대 핸드 보기",
  "trace.opponentHand": "상대 핸드",
  "trace.validCombos": "유효 조합",
  "trace.weight": "가중치",
  "trace.opponentValue": "상대 {value}",
  "trace.amountBb": "금액 bb",
  "trace.calculationPath": "계산 경로",
  "trace.opponentsAverageErw": "상대 평균 ERW",
  "trace.cacheHitMissing":
    "캐시 적중: key {key}. 원본 계산이 이 산출물에 기록되지 않아 상대 핸드 분해는 미기록입니다. 재계산하지 않습니다.",
  "trace.nwayAggregate":
    "N-way 레인지 집계 경로: hero ERW {heroErw}, 상대 평균 ERW {opponentsErw}, 유효 스택 {stack}bb, SPR {spr}. 기존 계산에 상대 핸드 쌍별 EV가 없어 임의의 쌍 표를 만들지 않습니다.",
  "trace.poolingTitle": "상대 평균 ERW 집계 입력",
  "trace.totalMass": "전체 질량",
  "trace.finalAggregation": "최종 집계 {status}",
  "trace.included": "포함",
  "trace.excluded": "제외",
  "trace.poolingCaption": "상대 평균 ERW의 핸드별 실제 계산 입력",
  "trace.mass": "질량",
  "trace.offsetFormula": "clamp(e + δ_hero − δ_opponent, −SPR, 1 + SPR)",
  "trace.openLearningTrace": "학습 트레이스 보기",
  "trace.caseMatchSource":
    "같은 인원수·스택의 다른 solve에서 기록한 트레이스입니다",
  "trace.solutionHasNoTrace": "이 솔루션은 트레이스를 생성하지 않았습니다",
  "trace.noNodeToOpen": "학습 트레이스를 열 노드가 없습니다",
  "trace.invalidEvEvidence": "유효하지 않은 EV 근거 응답입니다.",
  "trace.invalidEvNumber": "EV 근거에 유효하지 않은 숫자가 있습니다.",
  "trace.missingEvIdentifier": "EV 근거에 필수 식별자가 없습니다.",
  "trace.invalidErwApplied": "유효하지 않은 ERW 적용 상태입니다.",
  "trace.invalidErwAggressor": "유효하지 않은 ERW 공격자 좌석입니다.",
  "trace.invalidErwEvidenceList": "유효하지 않은 ERW 근거 목록입니다.",
  "trace.activeSeatsUnrecorded": "활성 좌석이 미기록입니다.",
  "trace.unsupportedErwVersion": "지원하지 않는 ERW 공식 버전입니다.",
  "trace.invalidOpponentPooling": "유효하지 않은 상대 ERW 집계입니다.",
  "trace.invalidOpponentPoolingInput": "유효하지 않은 상대 ERW 입력입니다.",
  "trace.invalidEvEvidenceList": "유효하지 않은 EV 근거 목록입니다.",
  "trace.invalidOpponentHandList": "유효하지 않은 상대 핸드 목록입니다.",
  "trace.invalidSidePotEvidence": "유효하지 않은 사이드팟 근거입니다.",
  "publicSolve.title": "공개 솔브",
  "publicSolve.missingToken": "공개 솔브 토큰이 없습니다.",
  "publicSolve.notFoundMessage": "공개 솔브를 찾을 수 없습니다.",
  "publicSolve.loadFailed": "공개 솔브를 불러오지 못했습니다.",
  "publicSolve.loading": "공개 솔브를 불러오는 중...",
  "publicSolve.notFound": "솔브를 찾을 수 없음",
  "publicSolve.unableToLoad": "솔브를 불러올 수 없음",
  "publicSolve.board": "보드",
  "publicSolve.exploitability": "익스플로잇 가능성",
  "publicSolve.iterations": "반복",
  "publicSolve.views": "조회수",
  "publicSolve.source": "출처",
  "publicSolve.created": "생성: {date}",
  "publicSolve.config": "설정",
  "publicSolve.result": "결과",
  "publicSolve.noResult": "결과 데이터 없음",
  "documents.backLabel": "이전 페이지로 돌아가기",
  "documents.back": "← 뒤로",
  "documents.title": "문서",
  "documents.locktreeDocuments": "Locktree 문서",
  "documents.description":
    "Locktree는 포커 GTO 전략을 실시간으로 계산하는 SaaS 솔버입니다. 아래는 솔버 개발에 참여하는 엔지니어를 위한 코드 수준 워크스루와 아키텍처 의사결정 기록(ADR), 사전계산 아티팩트입니다.",
  "documents.codeWalkthrough": "코드 워크스루",
  "documents.adr": "아키텍처 의사결정 기록",
  "documents.precomputeArtifacts": "사전계산 아티팩트",
  "documents.algorithmFlow": "알고리즘 흐름",
  "documents.architectureAdr": "아키텍처 ADR",
  "documents.preflopWalkthroughTitle": "프리플랍 CFR — 워크스루",
  "documents.preflopWalkthroughDescription":
    "프리플랍 솔버를 네 관점으로 따라갑니다. 실행 흐름은 HTTP 요청부터 게임 트리 순회까지, 타임라인은 InfoSet 내부 데이터(regret_sum_·strategy_sum_·prunable_mask_)의 단계별 변화, Terminal Utility는 터미널 노드의 utility·blocker·card removal 계산, GameNode 모델은 노드가 맡은 다섯 책임을 데이터 모델로 분해합니다.",
  "documents.postflopWalkthroughTitle": "포스트플랍 CFR 솔브 — 코드 워크스루",
  "documents.postflopWalkthroughDescription":
    "포스트플랍 솔버가 스트리트·서브게임·레인지를 따라 한 사이클을 어떻게 풀어가는지 추적합니다. 트리 구성부터 수렴 검사까지 핵심 단계를 단계별로 보여줍니다.",
  "documents.regretAdrTitle": "포스트플랍 MCCFR — Regret 동기화 ADR",
  "documents.regretAdrDescription":
    "포스트플랍 MCCFR의 regret 동기화 방식을 어떻게 결정했는지 기록한 ADR 문서입니다. 채택한 StripedNodeMutex 1024-stripe 구조의 동작과 코드 위치를 정리합니다.",
  "documents.openNewTab": "새 탭",
  "cardMnemonic.title": "카드 음절 암기",
  "cardMnemonic.nextQuestion": "다음 문제 (Space)",
  "cardMnemonic.showAnswer": "정답 보기 (Space)",
  "cardMnemonic.quizHelp":
    "두 장이 가리키는 두 글자를 떠올린 뒤 정답을 확인하세요.",
  "cardMnemonic.firstCard": "첫 번째 카드",
  "cardMnemonic.secondCard": "두 번째 카드",
  "cardMnemonic.collapseCombinations": "전체 조합 접기",
  "cardMnemonic.showCombinations": "전체 조합 보기 ({count}개)",
  "cardMnemonic.mnemonicWord": "암기 단어",
  "cardMnemonic.syllable": "음절",
  "cardMnemonic.collapseTable": "변환표 접기",
  "cardMnemonic.expandTable": "변환표 펼치기",
  "cardMnemonic.rankInitial": "랭크 → 초성",
  "cardMnemonic.suitMedial": "무늬 → 중성",
  "cardMnemonic.noFinalConsonant": "받침은 쓰지 않습니다. 음절 = 초성 + 중성.",
  "errorBoundary.chunkTitle": "청크 로드 오류",
  "errorBoundary.chunkMessage":
    "새 앱 번들이 있을 수 있습니다. 최신 버전을 받으려면 페이지를 새로고침하세요.",
  "errorBoundary.networkTitle": "네트워크 오류",
  "errorBoundary.networkMessage":
    "네트워크 요청이 실패해 React 앱 로드를 완료하지 못했습니다.",
  "errorBoundary.renderTitle": "렌더링 오류",
  "errorBoundary.renderMessage":
    "React 앱을 렌더링하는 중 예기치 않은 오류가 발생했습니다.",
  "errorBoundary.unableToLoad": "앱을 불러올 수 없습니다",
  "errorBoundary.reload": "새로고침",
  "game.tableTitle": "9-max GTO 봇 테이블",
  "game.setupHelp": "테이블을 설정하고 플레이를 시작하세요",
  "game.stackSize": "스택 크기: {stack} BB",
  "game.botStyles": "봇 스타일(플레이어 8명)",
  "game.seat": "좌석 {seat}",
  "game.start": "게임 시작",
  "game.presetAllGto": "모두 GTO",
  "game.presetMixed": "혼합 테이블",
  "game.presetShark": "샤크 탱크",
  "game.presetWild": "와일드 웨스트",
  "game.botGto": "GTO 균형형 (GTO Balanced)",
  "game.botLag": "루즈 어그레시브 (LAG)",
  "game.botTag": "타이트 어그레시브 (TAG)",
  "game.botLp": "루즈 패시브 (LP)",
  "game.botTp": "타이트 패시브 (TP)",
  "game.botManiac": "매니악 (Maniac)",
  "game.botRock": "록 (Rock)",
  "game.localPlay": "로컬 플레이",
  "game.localRoom": "로컬",
  "game.you": "나",
  "game.bot": "봇 {seat}",
  "game.preflop": "프리플랍",
  "game.flop": "플랍",
  "game.turn": "턴",
  "game.river": "리버",
  "game.fold": "폴드",
  "game.check": "체크",
  "game.callAmount": "콜 {amount}",
  "game.betAmount": "벳 {amount}",
  "game.raiseAmount": "레이즈 {amount}",
  "game.allIn": "올인",
  "game.handNumber": "핸드 #{number}",
  "game.sidePot": "사이드팟: {amount}",
  "game.staleBotResult": "이전 게임의 봇 결과라 무시했습니다.",
  "game.noActiveGame": "진행 중인 게임이 없습니다.",
  "convergence.targetsNotMet": "⚠️ 목표 미충족 결과입니다",
  "convergence.unavailable": "⚠️ 수렴 여부를 판정할 수 없습니다",
  "convergence.metrics":
    "· 익스플로잇 가능성 {exploitability} / 목표 {target} · 최대 격차 {gap} / 목표 {gapTarget}",
  "auth.genericError": "로그인할 수 없습니다. 다시 시도해 주세요.",
  "online.roomCode": "방 코드",
  "online.copyRoomCode": "클릭하면 복사됩니다",
  "online.copied": "복사됨!",
  "online.shareCode": "친구에게 이 코드를 공유하세요",
  "online.gameType": "게임 유형",
  "online.participants": "참가자 ({count}/9)",
  "online.me": "(나)",
  "online.host": "방장",
  "online.startGame": "게임 시작",
  "online.needPlayers": "2명 이상 모이면 시작할 수 있습니다",
  "online.waitingForHost": "방장이 게임을 시작하기를 기다리는 중…",
  "online.leaveRoom": "방 나가기",
  "online.title": "친구끼리 홀덤",
  "online.landingHelp": "방을 만들거나 코드로 들어와 함께 플레이하세요",
  "online.nickname": "닉네임",
  "online.nicknamePlaceholder": "테이블에 표시될 이름",
  "online.normalGame": "일반 게임",
  "online.normalGameHelp": "블라인드 고정 · 칩이 떨어질 때까지",
  "online.customGameHelp": "스택·레벨 길이·블라인드를 직접 입력",
  "online.createRoom": "새 방 만들기",
  "online.or": "또는",
  "online.joinCodePlaceholder": "방 코드",
  "online.join": "입장",
  "online.connectingServer": "서버에 연결 중…",
  "online.room": "방 {roomCode}",
  "online.eliminated": "{rank}위로 탈락했습니다 · 남은 게임을 관전합니다",
  "online.unknownPlayer": "알 수 없는 플레이어",
  "online.jointWinner": "공동 우승",
  "online.winner": "우승",
  "online.winnerAnnouncement": "{names} ({label})",
  "online.gameOver": "게임 종료",
  "online.finalStandings": "최종 순위",
  "online.resultUnavailable": "결과를 불러오지 못했습니다.",
  "online.backToLobby": "로비로",
  "online.onlineHoldem": "온라인 홀덤",
  "online.reconnectingTitle": "연결을 복구하는 중입니다",
  "online.reconnecting": "서버와 다시 연결하고 있습니다. 잠시만 기다려 주세요.",
  "online.connecting": "서버에 연결하는 중입니다...",
  "online.disconnected": "서버 연결이 끊겼습니다. 자동으로 다시 연결합니다.",
  "online.supersededTitle": "다른 탭에서 이 방에 접속했습니다",
  "online.supersededHelp":
    "게임은 다른 탭에서 계속 진행 중입니다. 이 탭에서 이어서 하려면 아래 버튼을 누르세요.",
  "online.continueHere": "이 탭에서 계속하기",
  "online.gameStatus": "게임 현황",
  "online.blinds": "블라인드",
  "online.ante": "앤티",
  "online.next": "다음",
  "online.startingStack": "시작 스택",
  "online.levelMinutes": "레벨 길이(분)",
  "online.endMethod": "종료 방식",
  "online.lastSurvivor": "마지막 1인이 남을 때까지",
  "online.lastSurvivorHelp": "순위는 탈락 순서",
  "online.afterFinalLevel": "마지막 레벨 후 종료",
  "online.afterFinalLevelHelp": "순위는 남은 칩",
  "online.levelBlinds": "레벨별 블라인드 (앤티는 비우면 없음)",
  "online.smallBlind": "스몰블라인드",
  "online.bigBlind": "빅블라인드",
  "online.level": "Lv {level}",
  "online.levelField": "레벨 {level} {field}",
  "online.deleteLevel": "레벨 {level} 삭제",
  "online.delete": "삭제",
  "online.addLevel": "레벨 추가",
  "online.tournament100bb": "토너먼트 100BB",
  "online.timeAttack": "타임어택",
  "online.custom": "사용자 지정",
  "online.beforeStart": "시작 전",
  "online.ended": "종료",
  "online.finalLevel": "최종 레벨",
  "online.nextHand": "다음 핸드부터",
  "online.finalHand": "이번 핸드까지",
  "online.tableTitle":
    "방 {roomCode} · {levelText} · {blindsText} · {countdownText}",
  "online.levelProgress": "Lv {current}/{total}",
  "online.anteValue": "앤티 {value}",
  "online.scheduleSummary":
    "{startingBigBlinds}BB 시작 · 레벨 {levelMinutes}분 · 블라인드 {smallBlind}/{bigBlind}부터",
  "online.scheduleSummaryFinal":
    "{startingBigBlinds}BB 시작 · 레벨 {levelMinutes}분 · 블라인드 {smallBlind}/{bigBlind}부터 · {levelCount}레벨 후 종료, 남은 칩으로 순위",
  "online.nextBlindsWithAnte": "{blinds} · 앤티 {ante}",
  "online.tournament": "토너먼트",
  "online.status": "상태",
  "online.untilNextLevel": "다음 레벨까지",
  "online.remainingTime": "남은 시간",
  "online.untilEnd": "종료까지",
  "online.errorReconnecting": "재접속 중입니다. 잠시 후 다시 시도해 주세요.",
  "online.errorDisconnected":
    "서버에 연결되어 있지 않습니다. 잠시 후 다시 시도해 주세요.",
  "online.errorTakeoverDelayed":
    "세션을 되찾는 중 응답이 지연됩니다. 다시 시도해 주세요.",
  "online.errorTakeoverFailed": "세션을 되찾지 못했습니다.",
  "online.errorReconnectFailed": "재접속하지 못했습니다.",
  "online.errorTakeoverDisconnected":
    "연결이 끊겨 세션을 되찾지 못했습니다. 다시 시도해 주세요.",
  "online.errorLeaveBeforeCreate":
    "방을 만들려면 먼저 현재 방을 나가야 합니다.",
  "online.errorCreateFailed": "방을 만들지 못했습니다.",
  "online.errorLeaveBeforeJoin":
    "방에 입장하려면 먼저 현재 방을 나가야 합니다.",
  "online.errorInvalidJoinResponse": "방 입장 응답이 유효하지 않습니다.",
  "online.errorJoinFailed": "방에 입장하지 못했습니다.",
  "online.errorStartFailed": "게임을 시작하지 못했습니다.",
  "online.errorActionFailed": "액션 실패",
  "online.errorNextHandFailed": "다음 핸드 실패",
  "online.errorReturnLobbyFailed": "로비로 돌아가지 못했습니다.",
  "online.errorLeaveFailed": "방을 나가지 못했습니다.",
  "online.invalidSchedule": "토너먼트 스케줄이 유효하지 않습니다.",
  "online.invalidStartingStack":
    "시작 스택은 1 이상 {maximum} 이하의 정수여야 합니다.",
  "online.invalidLevelMinutes":
    "레벨 길이는 {minimum}~{maximum}분의 정수여야 합니다.",
  "online.invalidEndMethod": "종료 방식이 유효하지 않습니다.",
  "online.invalidLevelCount": "레벨은 1~{maximum}개여야 합니다.",
  "online.invalidLevelFormat": "레벨 {level} 형식이 유효하지 않습니다.",
  "online.invalidBigBlind":
    "레벨 {level} 빅블라인드는 2 이상의 정수여야 합니다.",
  "online.invalidSmallBlind":
    "레벨 {level} 스몰블라인드는 1 이상이고 빅블라인드보다 작은 정수여야 합니다.",
  "online.invalidAnte":
    "레벨 {level} 앤티는 0 이상이고 빅블라인드 이하인 정수여야 합니다.",
  "online.invalidLevelOrder":
    "레벨 {level} 은 이전 레벨보다 줄어들지 않고 하나 이상 커야 합니다.",
  "online.invalidStartingStackBlind":
    "시작 스택은 첫 레벨 빅블라인드의 {multiple}배 이상이어야 합니다.",
  "pokerth.raiseSlider": "레이즈 금액 슬라이더",
  "pokerth.raiseAmount": "레이즈 금액",
  "pokerth.allInShortcut": "올인(A)",
  "pokerth.foldShortcut": "폴드(F)",
  "pokerth.checkShortcut": "체크(C)",
  "pokerth.callShortcut": "콜(C)",
  "pokerth.raiseShortcut": "레이즈(R)",
  "pokerth.actionPreview": "액션 미리보기",
  "pokerth.total": "합계:",
  "pokerth.bets": "벳:",
  "pokerth.room": "방:",
  "pokerth.quit": "나가기",
  "pokerth.handResult": "핸드 결과",
  "pokerth.youWon": "승리했습니다",
  "pokerth.handWinner": "핸드 승자",
  "pokerth.hand": "핸드",
  "pokerth.totalPot": "총 팟",
  "pokerth.players": "플레이어",
  "pokerth.blinds": "블라인드",
  "pokerth.communityCards": "커뮤니티 카드",
  "pokerth.results": "결과",
  "pokerth.nextHand": "다음 핸드",
  "pokerth.leaveTable": "테이블 나가기",
  "pokerth.winner": "승자",
  "handValidation.outOfTurn": "행동 순서가 맞지 않습니다.",
  "handValidation.minRaise": "레이즈 금액이 최소 레이즈 미만입니다.",
  "handValidation.minRaiseHelp":
    "최소 레이즈 to = max(직전 레이즈 크기, 빅블라인드) + 현재 벳 금액.",
  "handValidation.stackUnderflow": "벳 금액이 보유 스택을 초과합니다.",
  "handValidation.noReopen": "직전 숏 올인은 베팅을 다시 열지 못합니다.",
  "handValidation.noReopenHelp":
    "이미 행동한 플레이어는 이 상황에서 콜만 가능합니다.",
  "handValidation.raiseCovered": "스택이 콜 금액 이하라 레이즈할 수 없습니다.",
  "handValidation.raiseCoveredHelp": "콜로 처리하세요.",
  "handValidation.noEligibleOpponent":
    "레이즈를 받을 상대가 없습니다(나머지 전원 폴드/올인).",
  "handValidation.noMoreRaise":
    "이 라운드에서 더 이상 레이즈가 허용되지 않습니다.",
  "handValidation.illegalCheck": "콜해야 할 베팅이 있는데 체크했습니다.",
  "handValidation.illegalCheckHelp": "콜 또는 폴드해야 합니다.",
  "handValidation.streetPremature":
    "베팅 라운드가 끝나기 전에 다음 스트리트로 넘어갔습니다.",
  "handValidation.unknownAction": "해석할 수 없는 액션입니다.",
  "handValidation.unknownPlayer": "알 수 없는 플레이어",
  "handValidation.action": "액션",
  "handValidation.preflop": "프리플랍",
  "handValidation.flop": "플랍",
  "handValidation.turn": "턴",
  "handValidation.river": "리버",
  "handValidation.missingResponse":
    "{street}에서 {aggressor} {action} 이후 {player}의 응답 액션이 없습니다.",
  "handValidation.missingAction": "{street}에서 {player}의 액션이 없습니다.",
  "handValidation.missingResponseHelp":
    "원본 핸드 히스토리에서 해당 플레이어의 콜/폴드/레이즈 응답을 확인해 추가하세요.",
  "handValidation.missingActionHelp":
    "원본 핸드 히스토리에서 해당 플레이어의 체크/벳 액션을 확인해 추가하세요.",
  "handValidation.actionRequired": "{player} 액션 필요",
  "handValidation.missingBlinds":
    "프리플랍에 블라인드 납입 액션(Post SB, Post BB)이 없어 행동 순서 검증을 건너뜁니다.",
  "handValidation.missingBlindsHelp":
    "Post SB, Post BB를 추가하면 행동 순서까지 검증합니다.",
  "handValidation.withDetail": "{message} ({detail})",
  "handValidation.potTotalMismatch":
    "OHH 팟 합계({actual})가 실제 투입액({expected})과 다릅니다.",
  "handValidation.potTotalHelp":
    "현재 액션이 맞다면 pots[].amount 합계를 수정하세요: {actual} → {expected}.",
  "handValidation.collectedMismatch":
    "획득 합계({actual})가 팟 합계({expected})와 다릅니다.",
  "handValidation.collectedHelp":
    "player_wins[].win_amount와 pots[].amount를 확인하세요.",
  "handValidation.potCountMismatch":
    "OHH 팟 개수({actual})가 리플레이 팟 개수({expected})와 다릅니다.",
  "handValidation.potCountHelp": "사이드팟 경계와 pots[] 항목 수를 확인하세요.",
  "handValidation.potAmountMismatch":
    "OHH 팟 #{number} 금액({actual})이 리플레이 팟 금액({expected})과 다릅니다.",
  "handValidation.potAmountHelp":
    "현재 액션이 맞다면 pots[{index}].amount를 수정하세요: {actual} → {expected}.",
  "handValidation.ineligiblePlayer":
    "player_id {playerId}는 팟 #{number} 획득 자격이 없습니다.",
  "handValidation.ineligiblePlayerHelp":
    "올인 기여금보다 큰 사이드팟은 해당 플레이어가 획득할 수 없습니다.",
  "handValidation.positionNoActions":
    '플레이어 포지션 "{position}"에 블라인드/앤티를 제외한 프리플랍 액션이 없습니다.',
  "handValidation.parseFailed": "JSON 파싱 실패: {message}",
  "handValidation.rootObject": "OHH 루트는 JSON 객체여야 합니다.",
  "handValidation.ohhObject": "ohh는 JSON 객체여야 합니다.",
  "handValidation.missingGameType": "game_type이 없거나 비어 있습니다.",
  "handValidation.unsupportedGame":
    "지원하지 않는 게임(game_type={gameType}, bet_type={betType}). NL Hold'em만 검증합니다.",
  "handValidation.playersArray": "players는 배열이어야 합니다.",
  "handValidation.tooFewPlayers": "플레이어가 2명 미만입니다.",
  "handValidation.missingRounds": "rounds가 없거나 배열이 아닙니다.",
  "handValidation.invalidSmallBlind":
    "small_blind_amount가 없거나 0 이하입니다.",
  "handValidation.invalidBigBlind": "big_blind_amount가 없거나 0입니다.",
  "handValidation.playerObject": "player는 객체여야 합니다.",
  "handValidation.playerFieldMissing": "player.{field} 필드가 없습니다.",
  "handValidation.negativeStack":
    "player {playerId}의 starting_stack이 음수입니다.",
  "handValidation.duplicateCard": "중복 카드가 있습니다: {card}",
  "handValidation.roundObject": "round는 객체여야 합니다.",
  "handValidation.roundStreetMissing": "round.street가 없습니다.",
  "handValidation.roundActionsMissing": "round.actions가 없습니다.",
  "handValidation.boardCardCount":
    "{street} 보드 카드 수가 {count}장이 아닙니다.",
  "handValidation.badBoardCard": "유효하지 않은 보드 카드 형식: {card}",
  "handValidation.actionObject": "action은 객체여야 합니다.",
  "handValidation.actionNumberMissing": "action_number가 없습니다.",
  "handValidation.actionStringMissing": "action 문자열이 없습니다.",
  "handValidation.badHoleCard": "유효하지 않은 홀 카드 형식: {card}",
  "handValidation.actionPlayerMissing":
    "action {actionNumber}: player_id가 없습니다.",
  "handValidation.unknownPlayerId":
    "action {actionNumber}: 알 수 없는 player_id {playerId}",
  "handValidation.unknownActionMapping": "매핑할 수 없는 action: {action}",
  "results.hand": "핸드",
  "results.weightBar": "가중치(막대)",
  "results.combos": "콤보",
  "results.combosBar": "콤보(막대)",
  "results.eq": "EQ",
  "results.ev": "EV",
  "results.turn": "턴",
  "results.river": "리버",
  "results.reportsUnavailable": "{street} 리포트를 사용할 수 없습니다",
  "results.noResults": "결과 없음",
  "game.chipUnit": "칩",
  "preflopTree.raiseAmount": "레이즈 {amount}",
  "preflopSolution.loadingCached": "캐시된 전략을 불러오는 중…",
  "preflopSolution.loadingPrecomputed": "사전계산 전략을 불러오는 중…",
  "preflopSolution.initializingTree": "게임 트리를 초기화하는 중…",
  "preflopSolution.exportingResults": "결과를 내보내는 중…",
  "preflopSolution.solving": "솔브 중 ({current}/{target}{exploitability})…",
  "preflopSolution.timeout": "솔브가 15분 후 시간 초과되었습니다.",
  "preflopSolution.missingStrategyNodes":
    "전략 노드 없이 솔브가 완료되었습니다.",
  "resultViewer.workerInitFailed": "솔버 워커를 초기화하지 못했습니다.",
  "resultViewer.cachedTreeUnavailable":
    "캐시된 트리를 찾을 수 없거나 사용할 수 없습니다.",
  "resultViewer.cachedTreeLoadFailed": "캐시된 트리를 불러오지 못했습니다.",
  "dbItemPicker.parseError": "파싱 오류(잘못된 JSON)",
  "dbItemPicker.dataTypeMismatch": "데이터 유형이 일치하지 않습니다",
  "dbItemPicker.versionMismatch": "버전이 일치하지 않습니다",
  "dbItemPicker.invalidData": "유효하지 않은 데이터",
  "trace.unexpectedErrorResponse": "예상하지 못한 오류 응답입니다.",
  "trace.invalidResponse": "잘못된 프리플랍 트레이스 응답: {detail}",
  "treeConfig.handlerNotInitialized": "솔버 핸들러가 초기화되지 않았습니다.",
  "treeConfig.rebuiltTreeUnavailable":
    "다시 빌드한 트리를 가져오지 못했습니다.",
  "aiSetup.extractedField": "추출한 필드",
  "aiSetup.imageParseConfidence": "{label} 이미지 파싱 신뢰도 {confidence}%",
  "aiSetup.reviewScreenshotReason":
    "원본 스크린샷과 비교해 확인하세요: {reason}",
  "aiSetup.reviewScreenshot":
    "이 추출 필드를 원본 스크린샷과 비교해 확인하세요.",
  "pokerth.pot": "팟",
  "handHistory.unknownError": "알 수 없는 오류",
  "aiSetup.blindsAntes": "블라인드 / 앤티",
  "aiSetup.preflop": "프리플랍",
  "aiSetup.flop": "플랍",
  "aiSetup.turn": "턴",
  "aiSetup.river": "리버",
  "aiSetup.unknown": "알 수 없음",
  "preflopSolution.invalidResponse": "잘못된 프리플랍 솔브 응답: {detail}",
  "apiError.network":
    "서버에 연결할 수 없습니다. 인터넷 연결을 확인한 뒤 다시 시도해 주세요.",
  "apiError.server":
    "서버에서 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.",
  "apiError.invalidData":
    "입력한 데이터가 유효하지 않습니다. 내용을 확인해 주세요.",
  "apiError.parse": "서버 응답을 처리하지 못했습니다. 다시 시도해 주세요.",
  "apiError.unexpected":
    "예상하지 못한 오류가 발생했습니다. 다시 시도해 주세요.",
  "apiError.sessionExpired": "세션이 만료되었습니다. 다시 로그인해 주세요.",
  "apiError.permissionDenied": "이 작업을 수행할 권한이 없습니다.",
  "apiError.notFound": "요청한 항목을 찾을 수 없습니다.",
  "apiError.tooManyRequests":
    "요청이 너무 많습니다. 잠시 후 다시 시도해 주세요.",
  "apiError.requestInvalid":
    "요청을 처리하지 못했습니다. 입력 내용을 확인한 뒤 다시 시도해 주세요.",
  "httpClient.network":
    "서버에 연결할 수 없습니다. 인터넷 연결을 확인해 주세요.",
  "httpClient.cancelled": "요청이 취소되었습니다",
  "jsonResponse.empty":
    "{context}에서 빈 응답을 받았습니다(HTTP {status}). 서버 연결이 끊겼거나 시간이 초과되었을 수 있습니다. 다시 시도해 주세요.",
  "jsonResponse.malformed":
    "{context}에서 잘못된 JSON 응답을 받았습니다(HTTP {status}). 다시 시도해 주세요.",
  "apiContext.preflopHandAnalysis": "프리플랍 핸드 분석",
  "apiContext.preflopSolve": "프리플랍 솔브",
  "apiContext.preflopTraceProfile": "프리플랍 트레이스 프로필",
  "apiContext.preflopTraceSubtree": "프리플랍 트레이스 서브트리",
  "apiContext.preflopTerminalEvidence": "프리플랍 터미널 근거",
  "apiContext.reachingRangesJobStart": "도달 레인지 작업 시작",
  "apiContext.reachingRangesRequest": "도달 레인지 요청",
  "apiContext.reachingRangesPoll": "도달 레인지 진행 조회",
  "apiContext.aiSetupRun": "AI 셋업 실행",
  "apiContext.aiSetupPoll": "AI 셋업 진행 조회",
  "apiContext.fullSolverHandoff": "Full Solver 핸드오프 실행",
  "auth.registrationFailed": "회원가입에 실패했습니다",
  "auth.loginFailed": "로그인에 실패했습니다",
  "auth.resendVerificationFailed": "인증 메일을 다시 보내지 못했습니다",
  "auth.networkError": "네트워크 오류가 발생했습니다. 다시 시도해 주세요.",
  "auth.oauthEmailAlreadyRegistered":
    "이미 같은 이메일로 생성된 계정이 있습니다. 기존 로그인 방법으로 로그인해 주세요.",
  "auth.logoutFailed":
    "로그아웃을 완료하지 못했습니다. 잠시 후 다시 시도해 주세요.",
  "db.loginToSave": "레인지와 설정을 저장하려면 로그인해 주세요.",
  "db.loginToModify": "레인지와 설정을 수정하려면 로그인해 주세요.",
  "db.loginToDelete": "레인지와 설정을 삭제하려면 로그인해 주세요.",
  "lockTemplate.defaultStrategy": "전략 잠금",
  "lockTemplate.defaultNodeRemoval": "노드 제거 잠금",
  "lockTemplate.defaultRange": "레인지 잠금",
  "solverStage.aiSetup": "AI 셋업",
  "solverStage.preflopActionTree": "프리플랍 액션 트리",
  "solverStage.oopRange": "OOP 레인지",
  "solverStage.ipRange": "IP 레인지",
  "solverStage.board": "보드",
  "solverStage.treeConfiguration": "트리 설정",
  "solverStage.runSolver": "솔버 실행",
  "solverStage.result": "결과",
  "aiSetupView.importDescription":
    "테이블 스크린샷이나 핸드 히스토리를 솔버에서 사용할 수 있는 스팟으로 변환합니다.",
  "aiSetupView.preflopTreeDescription":
    "가져온 핸드의 프리플랍 전략을 포지션별로 확인합니다.",
  "aiSetupView.boardDescription":
    "포스트플랍 솔브에 사용할 커뮤니티 카드를 선택합니다.",
  "aiSetupView.treeDescription":
    "솔버 트리의 벳 사이즈, 팟, 스택을 설정합니다.",
  "aiSetupView.runDescription": "솔브를 시작하고 수렴 과정을 확인합니다.",
  "aiSetupView.resultDescription": "솔브한 스팟의 전략과 EV를 확인합니다.",
  "preflopOverview.premiumPairs": "프리미엄 페어(AA-JJ)",
  "preflopOverview.mediumPairs": "미들 페어(TT-77)",
  "preflopOverview.smallPairs": "스몰 페어(66-22)",
  "preflopOverview.bigBroadway": "빅 브로드웨이(AK-AJ, KQ)",
  "preflopOverview.mediumBroadway": "미들 브로드웨이(AT-KT, QJ-JT)",
  "preflopOverview.suitedConnectors": "수딧 커넥터",
  "preflopOverview.suitedAces": "수딧 에이스",
  "preflopOverview.otherCategory": "기타",
  "rangeParser.invalidWeightFormat": "가중치 형식이 올바르지 않습니다: {value}",
  "rangeParser.invalidWeightValue": "가중치 값이 올바르지 않습니다: {value}",
  "rangeParser.parseFailed": "레인지를 해석할 수 없습니다: {value}",
  "rangeParser.emptyExpression": "(빈 문자열)",
  "rangeParser.duplicateCard": "같은 카드를 두 번 사용할 수 없습니다",
  "rangeParser.invalidSuitedness": "유효하지 않은 수딧 구분입니다",
  "rangeParser.invalidRankCharacter": "유효하지 않은 랭크 문자입니다: {value}",
  "rangeParser.invalidRankIndex": "유효하지 않은 랭크 인덱스입니다: {value}",
  "rangeParser.invalidSuitCharacter": "유효하지 않은 무늬 문자입니다: {value}",
  "rangeParser.invalidComboIndex": "유효하지 않은 콤보 인덱스입니다: {value}",
  "rangeParser.invalidCardIndex": "유효하지 않은 카드 인덱스입니다: {value}",
  "rangeParser.invalidCombo": "유효하지 않은 콤보입니다: {value}",
  "rangeParser.invalidSuitednessSuffix":
    "유효하지 않은 수딧 접미사입니다: {value}",
  "rangeParser.invalidComboFormat": "유효하지 않은 콤보 형식입니다: {value}",
  "rangeParser.invalidRangeExpression":
    "유효하지 않은 레인지 표현식입니다: {value}",
  "rangeParser.mixedPairRange":
    "유효하지 않은 레인지 표현식입니다: {value} (페어와 논페어를 섞을 수 없습니다)",
  "rangeParser.inconsistentSuitedness":
    "레인지의 수딧 구분이 일관되지 않습니다: {value} (수딧/오프수딧/전체를 섞을 수 없습니다)",
  "rangeParser.higherRankMismatch":
    "유효하지 않은 레인지 표현식입니다: {value} (논페어 레인지는 높은 랭크가 같아야 합니다. 예: AK-AQ)",
  "rangeParser.invalidRowColumn": "유효하지 않은 행/열입니다: {row}, {column}",
  "treeManager.noTree": "불러온 트리가 없습니다",
  "treeManager.notEditing": "편집 모드가 아닙니다",
  "treeManager.emptyLine": "빈 라인입니다",
  "treeManager.unexpectedTerminal": "예상하지 못한 터미널 노드입니다",
  "treeManager.chanceWithoutChildren": "찬스 노드에 자식 노드가 없습니다",
  "utility.tooManyBetSizes": "벳 사이즈가 너무 많습니다",
  "utility.emptyString": "빈 문자열이 있습니다",
  "utility.invalidLine": "유효하지 않은 라인 문자열입니다",
  "utility.allIn": "올인",
  "utility.multiplicativeNotAllowed":
    "배수 사이즈를 사용할 수 없습니다: {value}",
  "utility.invalidMultiplicative": "유효하지 않은 배수 사이즈입니다: {value}",
  "utility.multiplierTooSmall": "배수는 1보다 커야 합니다: {value}",
  "utility.invalidAdditive": "유효하지 않은 가산 사이즈입니다: {value}",
  "utility.additionMustBeInteger": "가산 사이즈는 정수여야 합니다: {value}",
  "utility.additionTooLarge": "가산 사이즈가 너무 큽니다: {value}",
  "utility.raiseCapNotAllowed":
    "레이즈 상한이 있는 가산 사이즈를 사용할 수 없습니다: {value}",
  "utility.raiseCapMustBePositiveInteger":
    "레이즈 상한은 양의 정수여야 합니다: {value}",
  "utility.raiseCapTooLarge": "레이즈 상한이 너무 큽니다: {value}",
  "utility.invalidGeometric": "유효하지 않은 기하 사이즈입니다: {value}",
  "utility.geometricMustBePositiveInteger":
    "기하 사이즈는 양의 정수여야 합니다: {value}",
  "utility.geometricTooLarge": "기하 사이즈가 너무 큽니다: {value}",
  "utility.invalidBetSize": "유효하지 않은 벳 사이즈입니다: {value}",
  "jsonFormat.unrepresentable": "JSON으로 표현할 수 없는 값입니다",
  "validation.nodePathNegative":
    "노드 경로의 액션 인덱스는 0 이상이어야 합니다. 음수 값: {value}",
  "validation.actionIndicesNegative": "모든 액션 인덱스는 0 이상이어야 합니다.",
  "validation.nodePathFormat":
    "노드 경로 형식이 유효하지 않습니다. 쉼표로 구분한 숫자를 입력해 주세요(예: '0,1,2'). 숫자가 아닌 값이 있습니다.",
  "validation.probabilitySum":
    "{context}의 확률 합은 1.0이어야 합니다(현재 {sum}). 현재 값: [{values}].",
  "validation.probabilityFormat":
    '{context}의 확률 형식이 유효하지 않습니다: "{value}". 쉼표로 구분한 소수를 입력해 주세요(예: "0.0,1.0,0.0").',
  "validation.probabilityRange":
    "{context}의 확률 값이 유효하지 않습니다: {value}. 모든 확률은 0.0 이상 1.0 이하여야 합니다.",
  "validation.actionsRequired":
    "제거할 액션이 없습니다. 액션 인덱스를 하나 이상 입력해 주세요(예: 폴드는 '0', 레이즈는 '2').",
  "validation.actionIndicesFormat":
    "액션 인덱스 형식이 유효하지 않습니다. 쉼표로 구분한 숫자를 입력해 주세요(예: '0,2'). 숫자가 아닌 값이 있습니다.",
  "validation.handIndexRange":
    "핸드 인덱스는 0~1325여야 합니다. 입력값: {value}",
  "validation.handNotation": '핸드 표기 "{value}"가 유효하지 않습니다: {error}',
  "resultViewer.copyPlaceholder": "안녕하세요",
  "worker.buildTreeFailed": "트리를 빌드하지 못했습니다",
  "worker.missingTreeData": "트리 빌드 응답에 트리 데이터가 없습니다",
  "worker.stoppedByUser": "사용자가 솔버를 중지했습니다",
  "worker.solverError": "솔버에서 오류가 발생했습니다",
  "worker.cleanupResultUnavailable":
    "서버 정리 후 솔브 결과를 사용할 수 없습니다",
  "worker.failedStatus": "솔버가 오류 상태로 종료되었습니다",
  "worker.resultsFailed": "결과를 가져오지 못했습니다",
  "worker.incrementalJobIdMissing": "증분 결과를 조회할 작업 ID가 없습니다",
  "worker.currentResultsFailed": "현재 결과를 가져오지 못했습니다",
  "worker.jobIdMissing": "작업 ID가 없습니다",
  "worker.gameNotLoaded": "게임을 불러오지 않았습니다",
  "worker.actionsFailed": "이후 액션을 가져오지 못했습니다",
  "worker.gameStateMissing":
    "게임 상태가 캐시되지 않았습니다. applyHistory()가 호출되지 않았을 수 있습니다",
  "worker.treeNotBuilt":
    "트리를 아직 만들지 않았습니다. 트리를 먼저 만들어 주세요.",
  "worker.gameTreeUnavailable": "게임 트리를 사용할 수 없습니다",
  "worker.startFailed": "솔버를 시작하지 못했습니다",
  "worker.finalizeTimeout": "솔버 완료 대기 시간이 10분을 초과했습니다",
  "worker.invalidTreePath": "유효하지 않은 트리 경로입니다: [{path}]",
  "aiSetupClient.pollTimeout":
    "AI 셋업 진행 조회가 {seconds}초 후 시간 초과되었습니다. 서버에서는 계속 실행 중일 수 있습니다.",
  "aiSetupClient.nonObjectPayload":
    "{context}에서 객체가 아닌 세션 응답을 반환했습니다.",
  "aiSetupClient.missingSessionId":
    "{context}에서 session_id를 반환하지 않았습니다.",
  "aiSetupClient.unknownStage":
    "{context}에서 알 수 없는 세션 단계({stage})를 반환했습니다.",
  "aiSetupClient.unknownStatus":
    "{context}에서 알 수 없는 세션 상태({status})를 반환했습니다.",
  "aiSetupClient.networkError": "네트워크 오류",
  "aiSetupClient.pollingFailed": "AI 셋업 진행 조회에 실패했습니다: {error}",
  "aiSetupClient.failed": "AI 셋업에 실패했습니다({code}){detail}",
  "gtoScore.calculateFailed": "GTO 점수를 계산하지 못했습니다",
  "gtoScore.networkError": "네트워크 오류가 발생했습니다",
  "gtoScore.httpError": "HTTP 오류: {status} {statusText}",
  "gtoScore.fold": "폴드",
  "gtoScore.check": "체크",
  "gtoScore.call": "콜",
  "gtoScore.bet": "벳 ${amount}",
  "gtoScore.raise": "레이즈 ${amount}",
  "gtoScore.allIn": "올인 ${amount}",
  "gtoScore.postsSb": "SB 포스트",
  "gtoScore.postsBb": "BB 포스트",
  "gtoScore.postsAnte": "앤티 포스트",
  "gtoScore.unknown": "알 수 없음",
  "handHistory.analysisFailed": "프리플랍 핸드를 분석하지 못했습니다",
  "preflopSolve.htmlError":
    "서버 오류({status}): 서버가 JSON 대신 HTML 오류 페이지를 반환했습니다. 일반적으로 서버가 중단되었거나 시간이 초과되었음을 뜻합니다.",
  "preflopSolve.unexpectedResponse":
    "예상하지 못한 서버 응답입니다({status}). JSON을 기대했지만 다음 내용을 받았습니다: {body}",
  "publicSolve.invalidToken": "공개 솔브 토큰이 유효하지 않습니다",
  "reachingRanges.unknownError": "알 수 없는 오류",
  "reachingRanges.apiError": "API 오류({status}): {error}",
  "reachingRanges.missingJobId":
    "도달 레인지 API가 job_id를 반환하지 않았습니다",
  "reachingRanges.networkError": "네트워크 오류",
  "reachingRanges.pollingFailed": "진행 조회에 실패했습니다: {error}",
  "reachingRanges.pollError": "진행 조회 오류({status}){detail}",
  "reachingRanges.solveFailed": "CFR 솔브 실패: {error}",
  "reachingRanges.noErrorDetails":
    "서버가 오류 상세 내용을 반환하지 않았습니다",
  "reachingRanges.unexpectedStatus": '예상하지 못한 작업 상태: "{status}"',
  "scenario.serverError": "서버가 오류를 반환했습니다",
  "scenario.missingHandHistory": "서버 응답에 handHistory 필드가 없습니다",
  "scenario.parserUnavailable": "파서 API 서버({url})에 연결할 수 없습니다",
  "scenario.parserPortHelp": "서버가 8080 포트에서 실행 중인지 확인해 주세요",
  "scenario.apiUnavailable":
    "API 서버에 연결할 수 없습니다. 서버 실행 상태를 확인해 주세요.",
  "scenario.backendHelp": "백엔드 서버가 실행 중인지 확인해 주세요",
  "scenario.networkHelp": "네트워크 연결을 확인해 주세요",
  "scenario.imageParseFailed": "이미지를 파싱하지 못했습니다: {error}",
  "scenario.textParseFailed": "텍스트를 파싱하지 못했습니다: {error}",
  "solveHistory.invalidEntryId": "히스토리 항목 ID가 유효하지 않습니다",
  "bracketText.unexpectedFailure": "예상하지 못한 변환 오류: {error}",
  "bracketText.awayAsFold": "AWAY를 Fold로 변환했습니다",
  "bracketText.duplicateSection": "{marker} 섹션이 중복됩니다.",
  "bracketText.sectionOutOfOrder": "{marker} 섹션 순서가 유효하지 않습니다.",
  "bracketText.unknownSection": "알 수 없는 섹션 표기입니다.",
  "bracketText.missingSection": "{marker} 섹션이 없습니다.",
  "bracketText.unknownHeader": "알 수 없는 헤더 줄입니다.",
  "bracketText.missingHandNumber": "핸드 번호가 없습니다.",
  "bracketText.badBlindsHeader":
    "블라인드 헤더가 없거나 형식이 유효하지 않습니다.",
  "bracketText.badStackLine": "스택 줄 형식이 유효하지 않습니다.",
  "bracketText.unknownPosition": "알 수 없는 포지션: {position}.",
  "bracketText.duplicatePlayer": "플레이어 이름이 중복됩니다: {name}.",
  "bracketText.duplicatePosition": "포지션이 중복됩니다: {position}.",
  "bracketText.minimumPlayers": "플레이어가 두 명 이상이어야 합니다.",
  "bracketText.headsUpUnsupported":
    "헤즈업(2인) 핸드는 아직 지원하지 않습니다.",
  "bracketText.positionRequired": "{position} 포지션이 필요합니다.",
  "bracketText.singleDealtLine": "Dealt Cards 줄이 정확히 하나 있어야 합니다.",
  "bracketText.badDealtLine": "Dealt Cards 줄 형식이 유효하지 않습니다.",
  "bracketText.preflopPotRequired": "프리플랍 Pot 줄이 필요합니다.",
  "bracketText.boardCardsNotAllowed": "이 섹션에는 보드 카드가 없어야 합니다.",
  "bracketText.multiplePotLines": "한 섹션에 Pot 줄을 여러 개 둘 수 없습니다.",
  "bracketText.allInUnsupported": "올인 표기는 지원하지 않습니다.",
  "bracketText.badActionLine": "액션 줄 형식이 유효하지 않습니다.",
  "bracketText.unknownAction": "알 수 없는 액션 표기: {action}.",
  "bracketText.sidePotsUnsupported": "사이드팟은 지원하지 않습니다.",
  "bracketText.unknownWinnerPosition": "알 수 없는 승자 포지션: {position}.",
  "bracketText.unknownResultLine": "알 수 없는 결과 줄입니다.",
  "bracketText.winnerRequired": "Winner 줄이 필요합니다.",
  "bracketText.multipleWinnersUnsupported":
    "승자가 여러 명인 핸드는 지원하지 않습니다.",
  "bracketText.resultPotRequired": "결과 Pot 줄이 필요합니다.",
  "bracketText.playerMissing":
    "PRE-HAND STACKS에 없는 플레이어입니다: {player}",
  "bracketText.playerPositionMismatch":
    "{player}의 포지션이 PRE-HAND STACKS와 일치하지 않습니다.",
  "bracketText.winnerMissing": "PRE-HAND STACKS에 없는 승자입니다: {player}",
  "bracketText.winnerPositionMismatch":
    "승자 {player}의 포지션이 PRE-HAND STACKS와 일치하지 않습니다.",
  "bracketText.preflopOrderMismatch":
    "프리플랍 첫 등장 순서가 좌석 순서와 맞지 않습니다.",
  "bracketText.expectedBracketedCards":
    "카드 {count}장을 각각 대괄호로 묶어야 합니다.",
  "bracketText.invalidCard": "유효하지 않은 카드: {card}.",
  "bracketText.incompleteStructure": "필수 핸드 구조가 완성되지 않았습니다.",
  "bracketText.stackPrecision": "{player}의 스택이 지원 정밀도를 초과합니다.",
  "bracketText.preflopPotPrecision": "프리플랍 팟이 지원 정밀도를 초과합니다.",
  "bracketText.anteModelMismatch":
    "선언한 프리플랍 팟이 지원하는 앤티 납부 모델과 맞지 않습니다.",
  "bracketText.antePayersAmbiguous":
    "앤티 납부자 집합을 하나로 정할 수 없습니다.",
  "bracketText.heroMissing": "Hero가 PRE-HAND STACKS에 없습니다.",
  "bracketText.resultPotMismatch":
    "결과 팟과 변환한 기여금 합계가 일치하지 않습니다.",
  "bracketText.btnRequired": "딜러 좌석을 정하려면 BTN 포지션이 필요합니다.",
  "bracketText.winnerAbsent": "승자가 PRE-HAND STACKS에 없습니다.",
  "bracketText.forcedBetExceedsStack":
    "강제 벳이 {player}의 스택을 초과합니다.",
  "bracketText.actionExceedsStack": "{player}의 액션이 시작 스택을 초과합니다.",
  "bracketText.actionAmountMissing": "{action} 금액이 없습니다.",
  "bracketText.actionTargetTooSmall":
    "{action} 목표 금액은 해당 플레이어가 이 스트리트에 기여한 금액보다 커야 합니다.",
  "bracketText.declaredPotMismatch":
    "선언한 Pot과 변환한 기여금 합계가 일치하지 않습니다.",
  "bracketText.badMoney": "금액 형식이 유효하지 않습니다.",
  "bracketText.moneyPrecision": "금액 정밀도가 지원 범위를 초과합니다.",
  "bracketText.valuePrecision": "{label} 금액이 지원 정밀도를 초과합니다.",
  "bracketText.smallBlind": "스몰 블라인드",
  "bracketText.bigBlind": "빅 블라인드",
  "bracketText.ante": "앤티",
  "pokerStars.exportFailed": "PokerStars 텍스트로 내보낼 수 없습니다: {detail}",
  "pokerStars.duplicateCards": "같은 카드가 두 번 나옵니다: {cards}",
  "pokerStars.unreadableCards": "읽지 못한 카드가 있습니다: {cards}",
  "pokerStars.invalidHeroCardCount":
    "Hero 홀카드는 2장이어야 하는데 {actual}장입니다",
  "pokerStars.buttonBlindMismatch":
    "버튼 좌석 {buttonSeat}은 스몰 블라인드 좌석 {smallBlindSeat} 기준 좌석 {expectedButtonSeat}이어야 합니다",
  "pokerStars.unsupportedBetLimit": "지원하지 않는 베팅 리밋: {betType}",
  "pokerStars.unsupportedCurrency":
    "지원하지 않는 통화: {currency} (지원: USD, EUR, GBP, CNY)",
  "pokerStars.unsupportedGameType": "지원하지 않는 게임 유형: {gameType}",
  "pokerStars.unsupportedAction": "지원하지 않는 액션: {action}",
  "pokerStars.unknownPlayer":
    "액션 {actionNumber}에서 알 수 없는 플레이어: {playerId}",
  "pokerStars.unknownPotWinner": "알 수 없는 팟 승자: {playerId}",
  "pokerStars.duplicatePlayerId": "플레이어 ID가 중복됩니다: {playerId}",
  "pokerStars.duplicateSeat": "좌석이 중복됩니다: {seat}",
  "pokerStars.heroNotSeated": "좌석에 없는 Hero 플레이어: {playerId}",
  "pokerStars.dealerSeatEmpty": "딜러 좌석이 비어 있습니다: {seat}",
  "pokerStars.minimumPlayers": "핸드에 플레이어가 두 명 이상 있어야 합니다",
  "pokerStars.unexpectedStreetOrder": "예상하지 못한 스트리트 순서: {street}",
  "pokerStars.boardCardCount": "{street}에 보드 카드 {expected}장이 필요합니다",
  "pokerStars.invalidAmount": "{where}의 금액이 유효하지 않습니다",
  "pokerStars.inconsistentAmount":
    "액션 {actionNumber}의 금액이 일관되지 않습니다",
  "pokerStars.callExceedsAmount":
    "액션 {actionNumber}의 콜 금액이 필요한 콜 금액을 초과합니다",
  "pokerStars.shortCallWithoutAllIn":
    "올인 없는 숏콜입니다: 액션 {actionNumber}",
  "pokerStars.stackOvercommit":
    "액션 {actionNumber}에서 {player}의 투입 칩이 스택을 초과했습니다",
  "pokerStars.potTotalMismatch":
    "팟 합계({pot})와 기여금({contribution})이 일치하지 않습니다",
  "pokerStars.potWinsMismatch":
    "획득액 {collected}, 레이크 {rake}, 잭팟 {jackpot}의 합이 팟 합계({pot})와 일치하지 않습니다",
  "pokerStarsEdit.sourceUnreadable": "원본 핸드 히스토리를 읽을 수 없습니다.",
  "pokerStarsEdit.sourceCannotShow": "원본 핸드를 표시할 수 없습니다: {detail}",
  "pokerStarsEdit.lineCountChanged":
    "줄을 추가하거나 삭제할 수 없습니다. 기존 줄만 수정해 주세요.",
  "pokerStarsEdit.fixedLine":
    "이 줄은 수정할 수 없습니다. 스택, 카드, 액션만 수정할 수 있습니다.",
  "pokerStarsEdit.expectedSeat":
    '"Seat {seat}: {player} (<stack> in chips)" 형식이어야 합니다. 스택만 수정할 수 있습니다.',
  "pokerStarsEdit.expectedAction":
    '"{player}: folds | checks | calls <amount> | bets <amount> | raises <increase> to <total>" 형식이어야 합니다. 플레이어는 바꿀 수 없습니다.',
  "pokerStarsEdit.actionMissing": "이 액션은 원본 핸드에 없습니다.",
  "pokerStarsEdit.expectedDealt":
    '"Dealt to {player} [<cards>]" 형식이어야 합니다. Hero 카드만 수정할 수 있습니다.',
  "pokerStarsEdit.expectedShows":
    '"{player}: shows [<cards>]" 형식이어야 합니다.',
  "pokerStarsEdit.expectedStreet":
    "같은 수의 새 카드가 있는 동일한 스트리트 헤더가 필요합니다.",
  "pokerStarsEdit.invalidCard": '유효하지 않은 카드: "{card}"',
  "pokerStarsEdit.expectedCards": "카드가 {count}장이어야 합니다.",
  "pokerStarsEdit.cardsMissing": "이 카드는 원본 핸드에 없습니다.",
  "pokerStarsEdit.duplicateCard": "중복 카드: {cards}",
  "pokerStarsEdit.editedCannotShow":
    "수정한 핸드를 표시할 수 없습니다: {detail}",
  "pokerStarsEdit.outputMismatch":
    "수정 내용으로 만든 핸드와 일치하지 않습니다. 예상: {expected}",
  "pokerStarsEdit.shownCardsMustMatch":
    "공개한 카드는 받은 카드와 같아야 합니다.",
  "pokerStarsEdit.noLine": "(줄 없음)",
  "pokerStarsProjection.unknownError": "알 수 없는 변환 오류",
  "pokerStarsProjection.unsupportedInput":
    "지원하지 않는 핸드 히스토리 입력입니다",
  "pokerStarsProjection.unsupportedDocument": "지원하지 않는 OHH 문서입니다",
  "handHistory.lineIssue": "{line}번 줄 [{section}]: {message}",
  "ohh.expectedString": "문자열이어야 합니다",
  "ohh.expectedFiniteNumber": "유한한 숫자여야 합니다",
  "ohh.expectedArray": "배열이어야 합니다",
  "ohh.expectedObject": "객체여야 합니다",
  "ohh.expectedBoolean": "불리언이어야 합니다",
  "ohh.expectedArrayOrEmpty": "배열, null, 빈 문자열 또는 생략 값이어야 합니다",
  "ohh.expectedNonEmptyString": "비어 있지 않은 문자열이어야 합니다",
  "ohh.expectedPlayer": "플레이어가 한 명 이상 있어야 합니다",
  "ohh.expectedRound": "라운드가 하나 이상 있어야 합니다",
  "ohh.badPotNumbering":
    "팟 번호가 공식 0 기반 또는 호환 1 기반 규칙과 맞지 않습니다",
  "ohh.expectedUnitMarker": '단위 표시가 있으면 "{unit}"이어야 합니다',
  "ohh.expectedPositiveNumber": "양수여야 합니다",
  "ohh.invalidJson": "유효하지 않은 JSON: {error}",
  "ohh.jsonSyntaxError": "{error}",
  "ohhParser.missingGameNumber": "game_number가 없습니다",
  "ohhParser.minimumPlayers": "핸드에 플레이어가 두 명 이상 있어야 합니다",
  "ohhParser.missingRounds": "rounds가 없습니다",
  "ohhParser.heroNotFound": "Hero 플레이어를 찾을 수 없습니다",
  "ohhParser.preflopFoldedOut":
    "프리플랍에서 모든 플레이어가 폴드해 핸드가 끝났습니다(활성 플레이어 {count}명). 설정을 적용하려면 활성 플레이어 2명의 포스트플랍 액션이 필요합니다.",
  "ohhParser.preflopActivePlayers":
    "프리플랍에서 핸드가 끝났습니다(활성 플레이어 {count}명). 설정을 적용하려면 정확히 활성 플레이어 2명의 헤즈업 포스트플랍 액션이 필요합니다.",
  "ohhParser.multiwayUnsupported":
    "플랍에 플레이어 {count}명이 남은 멀티웨이 팟입니다. 설정 적용은 헤즈업(2인)만 지원합니다.",
  "ohhParser.notEnoughActivePlayers":
    "플랍의 활성 플레이어가 {count}명으로 부족합니다. 설정을 적용하려면 헤즈업(2인)이 필요합니다.",
  "ohhParser.cannotIdentifyPositions": "포지션을 확인할 수 없습니다: {reason}",
  "ohhParser.invalidHandState": "핸드 상태가 유효하지 않습니다",
  "ohhParser.postflopRequired":
    "핸드가 플랍에 도달하지 않았습니다. OOP/IP 포지션은 포스트플랍에만 적용됩니다.",
  "ohhParser.playerSeatsNotFound":
    "hand.players에서 플레이어 좌석을 찾을 수 없습니다",
  "ohhEditor.negativeStack": "스택은 음수가 될 수 없습니다",
  "ohhEditor.negativeAmount": "금액은 음수가 될 수 없습니다",
} as const;

export type MessageKey = keyof typeof ko;
export type MessageCatalog = Record<MessageKey, string>;
